import { DEFAULT_BLUEPRINT_DETAILS } from "@/containers/ChatGPT/reducer";

const DEFAULT_USE_CASE_SETTINGS = {
  ...DEFAULT_BLUEPRINT_DETAILS,
  isSample: true,
  created_date: "2026-01-01T00:00:00",
  updated_date: "2026-01-01T00:00:00"
};

const BANK_LOAN_FAIRNESS = {
  ...DEFAULT_USE_CASE_SETTINGS,
  outcome_behavior: "MAXIMIZE",
  id: "BANK_LOAN_FAIRNESS",
  name: "Bank Loan Fairness",
  suggested_fields: [],
  wizard: {
    setup: {
      goal: "Maximize",
      mode: 2,
      label: "Bank Loan Fairness",
      todos: {
        FAIR_GUIDE: {
          x: 10,
          y: 7,
          id: "FAIR_GUIDE",
          text: "Add AI Fairness Guidelines",
          color: "#54C06C",
          index: 2,
          parent: {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: {
              x: 1,
              y: 0
            },
            oChildDelta: {
              x: 1,
              y: -1
            },
            sectionType: "FAIRNESS"
          },
          actionId: 1,
          afterText: "Fairness guidelines have been defined",
          hasUpdate: true,
          borderColor: "#54C06C",
          isTemporary: false,
          leftSection: "FAIR_GUIDE"
        },
        OPTIMIZE_STRATEGY: {
          x: 8,
          y: 8,
          id: "OPTIMIZE_STRATEGY",
          text: "Add Business Strategy Recommendations",
          color: "#7E69D7",
          index: 0,
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: {
              x: 0,
              y: -1
            },
            sectionType: "STRATEGY"
          },
          actionId: 3,
          afterText: "Strategy Updated",
          hasUpdate: true,
          isTemporary: false,
          leftSection: "STRATEGY"
        },
        EVAL_MODEL_DRIVERS: {
          id: "EVAL_MODEL_DRIVERS",
          icon: "Gears",
          text: "Evaluate Model Drivers",
          color: "#7E69D7",
          index: 1,
          parent: {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: {
              x: 0,
              y: 1
            },
            oChildDelta: {
              x: 0,
              y: 1
            },
            sectionType: "DEPLOY"
          },
          actionId: 999,
          hideSave: true,
          hasUpdate: true,
          borderColor: "#247ADF",
          isTemporary: false,
          leftSection: "REVIEW_AI"
        }
      },
      total: 20000,
      models: [],
      ignored: {},
      useCase: "Sales Prediction",
      aimToHit: 800,
      endState: [],
      targeted: 2000,
      unitType: "$",
      auditable: false,
      datasetId: "3957",
      hideCosts: false,
      threshold: [0, 0],
      contAction: "Sell",
      errorCosts: {
        conversionCost: -200,
        conversionGain: 656,
        conversionSaved: 0,
        conversionMissed: 0
      },
      fieldTypes: {},
      isForecast: false,
      isQuickRun: false,
      timePeriod: "Year",
      trueAction: "Review",
      blueprintId: 37,
      falseAction: "Ignore",
      isBlueprint: true,
      splitColumn: "Ethnicity",
      advancedCost: 200,
      customValues: {
        Review_Cost: 200,
        Average_Loan: 38000,
        Closing_Fees: 500,
        Servicing_Cost: 100,
        Loan_Margin_Percent: 1.2
      },
      fieldReplace: {},
      modelOptions: [],
      outcomeLabel: "Funded Loan",
      processLimit: 0,
      showBusiness: true,
      trueNegative: 55800,
      truePositive: 3976,
      advancedInput: {},
      biasReduction: "Impact",
      falseNegative: 4200,
      falsePositive: 36024,
      ignoredModels: {},
      modelsReducer: {
        todos: {
          FAIR_GUIDE: {
            x: 10,
            y: 7,
            id: "FAIR_GUIDE",
            text: "Add AI Fairness Guidelines",
            color: "#54C06C",
            index: 2,
            parent: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            actionId: 1,
            afterText: "Fairness guidelines have been defined",
            hasUpdate: true,
            borderColor: "#54C06C",
            isTemporary: false,
            leftSection: "FAIR_GUIDE"
          },
          OPTIMIZE_STRATEGY: {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 0,
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            isTemporary: false,
            leftSection: "STRATEGY"
          },
          EVAL_MODEL_DRIVERS: {
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 1,
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: {
                x: 0,
                y: 1
              },
              oChildDelta: {
                x: 0,
                y: 1
              },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI"
          }
        },
        hexMap: {
          "7_8": {
            x: 7,
            y: 8,
            id: "DEPLOY",
            icon: "Rocket",
            text: "I want to deploy the current AI",
            color: "#EC6417",
            index: 3,
            selected: {
              0: {
                id: "DEPLOY_REVIEW",
                text: "Review & Approve Deployment Settings",
                borderColor: "#EC6417",
                leftSection: "DEPLOY_SETTINGS"
              },
              1: {
                id: "DEPLOY_INTEGRATION",
                text: "Integrate into your business systems",
                afterText: "Integration has been added",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "INTEGRATE"
              },
              2: {
                id: "DEPLOY_MONITOR",
                text: "Add Monitoring Settings",
                afterText: "Monitoring settings have been updated",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "MONITOR"
              }
            },
            background: "#EC6417",
            childDelta: {
              x: -1,
              y: 1
            },
            oChildDelta: {
              x: -1,
              y: 0
            },
            sectionType: "DEPLOY"
          },
          "8_7": {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: {
              x: 0,
              y: -1
            },
            sectionType: "STRATEGY"
          },
          "8_9": {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: {
              x: 0,
              y: 1
            },
            oChildDelta: {
              x: 0,
              y: 1
            },
            sectionType: "DEPLOY"
          },
          "9_7": {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: {
              x: 1,
              y: 0
            },
            oChildDelta: {
              x: 1,
              y: -1
            },
            sectionType: "FAIRNESS"
          },
          "9_8": {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: {
              x: 1,
              y: 1
            },
            oChildDelta: {
              x: 1,
              y: 1
            },
            sectionType: "BUDGET"
          }
        },
        isTodo: true,
        centerHex: {
          x: {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "EXPECTED"
          },
          y: {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "EXPECTED"
          }
        },
        isLoading: false,
        beforeSetup: {},
        replayIndex: 0,
        savedHexMap: {
          "7_7": {
            x: 7,
            y: 8,
            icon: "Join",
            text: "Dataset Name",
            color: "#059669",
            isBase: true,
            leftSection: "DATASET"
          },
          "8_5": {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 3,
            author: "Aible Demo",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            parentHex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            leftSection: "STRATEGY",
            updatedDate: 1634504716355
          },
          "8_6": {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            index: 2,
            author: "Aible Demo",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            parentHex: {
              x: 8,
              y: 8
            },
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "Bank Loan Fairness",
              total: 20000,
              models: [],
              ignored: {},
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "3957",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: {
                conversionCost: -200,
                conversionGain: 656,
                conversionSaved: 0,
                conversionMissed: 0
              },
              fieldTypes: {},
              isForecast: false,
              isQuickRun: false,
              timePeriod: "Year",
              trueAction: "Review",
              blueprintId: 16,
              falseAction: "Ignore",
              isBlueprint: true,
              splitColumn: "Ethnicity",
              advancedCost: 200,
              customValues: {
                Review_Cost: 200,
                Average_Loan: 38000,
                Closing_Fees: 500,
                Servicing_Cost: 100,
                Loan_Margin_Percent: 1.2
              },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Funded Loan",
              processLimit: 0,
              showBusiness: true,
              trueNegative: 55800,
              truePositive: 3976,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 4200,
              falsePositive: 36024,
              ignoredModels: {},
              conversionCost: -200,
              conversionGain: 656,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Net Profit",
              advancedRevenue: 956,
              conversionSaved: 0,
              notPursuedRatio: "7",
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: 0,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Applications",
              advancedCostLabel: "Review Effort",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Cost",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Ignored",
              truePositiveLabel: "Loan Approval",
              falseNegativeLabel: "Missed",
              falsePositiveLabel: "Loan Rejection",
              underPredictAction: "Underestimate Cost",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Loan Revenue",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Loan Prospects"
            },
            isTemporary: true,
            leftSection: "EXPECTED",
            updatedDate: 1634504699115
          },
          "8_8": {
            x: 8,
            y: 8,
            icon: "Blueprint",
            text: "Marketing Use Case",
            color: "#7e69d7",
            isBase: true,
            canStart: false,
            selected: {},
            leftSection: "HOME"
          },
          "10_7": {
            x: 10,
            y: 7,
            id: "FAIR_GUIDE",
            text: "Add AI Fairness Guidelines",
            color: "#54C06C",
            index: 5,
            author: "Aible Demo",
            parent: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            actionId: 1,
            afterText: "Fairness guidelines have been defined",
            hasUpdate: true,
            parentHex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            borderColor: "#54C06C",
            leftSection: "FAIR_GUIDE",
            updatedDate: 1634504731966
          },
          "8_10": {
            x: 8,
            y: 10,
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 4,
            author: "Aible Demo",
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: {
                x: 0,
                y: 1
              },
              oChildDelta: {
                x: 0,
                y: 1
              },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            parentHex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI",
            updatedDate: 1634504716356
          }
        },
        actionHexMap: {},
        savedActions: [
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            hex: {
              x: 8,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: {
                  x: 0,
                  y: -1
                },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              leftSection: "EXPECTED"
            },
            hex: {
              x: 9,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            nHex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: {
                    x: 0,
                    y: -1
                  },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            node: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: {
                  x: 0,
                  y: -1
                },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "EXPECTED"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "EXPECTED"
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            hex: {
              x: 8,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            hex: {
              x: 9,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          }
        ],
        todoMaximize: {
          OPTIMIZE_COSTS: true
        }
      },
      conversionCost: -200,
      conversionGain: 656,
      conversionRate: 5,
      customMappings: {},
      netImpactLabel: "Net Profit",
      advancedRevenue: 956,
      conversionSaved: 0,
      notPursuedRatio: "7",
      numberPredicted: "Price",
      realTimeResults: false,
      aiTrainingBudget: 200,
      conversionMissed: 0,
      hasLinkedProject: false,
      isForceOptimized: false,
      transactionLabel: "Applications",
      advancedCostLabel: "Review Effort",
      businessObjective: "Profit",
      fairnessObjective: "None",
      overPredictAction: "Overestimate Cost",
      overestimateLabel: "Overestimate",
      trueNegativeLabel: "Ignored",
      truePositiveLabel: "Loan Approval",
      falseNegativeLabel: "Missed",
      falsePositiveLabel: "Loan Rejection",
      underPredictAction: "Underestimate Cost",
      underestimateLabel: "Underestimate",
      academicResultsStep: 0,
      humanUnderstandable: false,
      advancedRevenueLabel: "Loan Revenue",
      baselineCustomValues: {},
      maximumConversionRate: 5,
      fairnessToleranceBound: 1,
      notPursuedTransactionLabel: "Loan Prospects"
    },
    dataset: {
      id: "BANK_LOAN_FAIRNESS",
      name: "Bank Loan Fairness Demo.csv",
      label: "Bank Loan Fairness Demo.csv",
      errors: [],
      fields: {
        Age: {
          type: "categorical",
          label: "Age"
        },
        Term: {
          type: "categorical",
          label: "Term"
        },
        Offer: {
          type: "categorical",
          label: "Offer"
        },
        Gender: {
          type: "categorical",
          label: "Gender"
        },
        Region: {
          type: "categorical",
          label: "Region"
        },
        Tenure: {
          type: "categorical",
          label: "Tenure"
        },
        Balance: {
          type: "number",
          label: "Balance"
        },
        Channel: {
          type: "categorical",
          label: "Channel"
        },
        Comm_Id: {
          type: "categorical",
          label: "Comm_Id"
        },
        Lead_Id: {
          type: "categorical",
          label: "Lead_Id"
        },
        Premium: {
          type: "categorical",
          label: "Premium"
        },
        Product: {
          type: "categorical",
          label: "Product"
        },
        Category: {
          type: "categorical",
          label: "Category"
        },
        Phone_No: {
          type: "categorical",
          label: "Phone_No"
        },
        Ethnicity: {
          type: "categorical",
          label: "Ethnicity"
        },
        Product_Id: {
          type: "categorical",
          label: "Product_Id"
        },
        Time_Stamp: {
          type: "date",
          label: "Time_Stamp"
        },
        Campaign_Id: {
          type: "categorical",
          label: "Campaign_Id"
        },
        Email_Count: {
          type: "categorical",
          label: "Email_Count"
        },
        Launch_Date: {
          type: "date",
          label: "Launch_Date"
        },
        Time_Of_Day: {
          type: "categorical",
          label: "Time_Of_Day"
        },
        Credit_Score: {
          type: "categorical",
          label: "Credit_Score"
        },
        Sub_Category: {
          type: "categorical",
          label: "Sub_Category"
        },
        Campaign_Name: {
          type: "categorical",
          label: "Campaign_Name"
        },
        "Loan Approved": {
          type: "categorical",
          label: "Loan Approved"
        },
        Household_Size: {
          type: "categorical",
          label: "Household_Size"
        },
        Marital_Status: {
          type: "categorical",
          label: "Marital_Status"
        },
        Call_For_Action: {
          type: "categorical",
          label: "Call_For_Action"
        },
        Net_Amt_Insured: {
          type: "categorical",
          label: "Net_Amt_Insured"
        },
        Campaign_Drivers: {
          type: "categorical",
          label: "Campaign_Drivers"
        },
        Customer_Segment: {
          type: "categorical",
          label: "Customer_Segment"
        },
        No_Of_Dependents: {
          type: "categorical",
          label: "No_Of_Dependents"
        },
        Focused_Geography: {
          type: "categorical",
          label: "Focused_Geography"
        },
        Payment_Frequency: {
          type: "categorical",
          label: "Payment_Frequency"
        },
        Products_with_Bank: {
          type: "categorical",
          label: "Products_with_Bank"
        },
        Tenure_Of_Campaign: {
          type: "categorical",
          label: "Tenure_Of_Campaign"
        },
        Amt_On_Maturity_Bin: {
          type: "categorical",
          label: "Amt_On_Maturity_Bin"
        },
        Annual_Income_Bucket: {
          type: "categorical",
          label: "Annual_Income_Bucket"
        },
        No_Of_People_Covered: {
          type: "categorical",
          label: "No_Of_People_Covered"
        },
        Online_Touchpoints_Count: {
          type: "categorical",
          label: "Online_Touchpoints_Count"
        }
      },
      labels: [
        "Lead_Id",
        "Age",
        "Phone_No",
        "Annual_Income_Bucket",
        "Credit_Score",
        "No_Of_Dependents",
        "Ethnicity",
        "Customer_Segment",
        "Products_with_Bank",
        "Household_Size",
        "Gender",
        "Marital_Status",
        "Time_Of_Day",
        "Campaign_Id",
        "Balance",
        "Comm_Id",
        "Time_Stamp",
        "Product",
        "Category",
        "Term",
        "No_Of_People_Covered",
        "Premium",
        "Payment_Frequency",
        "Amt_On_Maturity_Bin",
        "Sub_Category",
        "Campaign_Drivers",
        "Launch_Date",
        "Call_For_Action",
        "Focused_Geography",
        "Tenure_Of_Campaign",
        "Net_Amt_Insured",
        "Product_Id",
        "Online_Touchpoints_Count",
        "Email_Count",
        "Tenure",
        "Offer",
        "Channel",
        "Region",
        "Campaign_Name",
        "Loan Approved"
      ],
      source: {
        url: "s3://aible-769303959801-dev-2369/uploads/dev/uploads/tenant_2/98cc6e/raw",
        type: {
          id: 1,
          status: "ACTIVE",
          pattern: "s3:\\/\\/([^/]+)(?=\\/)\\/?(.*)",
          service_name: "S3",
          provider_name: "Amazon"
        },
        content: {
          type: "RAW_DATA"
        }
      },
      status: ["indexed"],
      target: "Loan Approved",
      created: "2021-08-16T14:00:37",
      deleted: false,
      outcome: "Loan Approved",
      isHidden: true,
      rowCount: 100000,
      stack_id: null,
      warnings: [
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Lead_Id",
            message: "Column 'Lead_Id' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Phone_No",
            message: "Column 'Phone_No' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Category",
            message: "Column 'Category' has only one unique value.  It would be discarded."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Focused_Geography",
            message: "Column 'Focused_Geography' has only one unique value.  It would be discarded."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column No_Of_Dependents has 961 missing values out of 100000 total values, comprising 0.96 % of the data in this column.",
          metadata: {
            column: "No_Of_Dependents",
            percentage: 0.961,
            num_missing: 961,
            num_observed: 99039,
            unique_message:
              " Column No_Of_Dependents has 961 missing values out of 100000 total values, comprising 0.96 % of the data in this column."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Products_with_Bank has 1019 missing values out of 100000 total values, comprising 1.02 % of the data in this column.",
          metadata: {
            column: "Products_with_Bank",
            percentage: 1.019,
            num_missing: 1019,
            num_observed: 98981,
            unique_message:
              " Column Products_with_Bank has 1019 missing values out of 100000 total values, comprising 1.02 % of the data in this column."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Household_Size has 1006 missing values out of 100000 total values, comprising 1.01 % of the data in this column.",
          metadata: {
            column: "Household_Size",
            percentage: 1.006,
            num_missing: 1006,
            num_observed: 98994,
            unique_message:
              " Column Household_Size has 1006 missing values out of 100000 total values, comprising 1.01 % of the data in this column."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Lead_Id",
            message:
              "Lead_Id has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-08-16T14:01:26"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Phone_No",
            message:
              "Phone_No has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-08-16T14:01:26"
        }
      ],
      accountId: 2369,
      file_size: 30,
      folder_id: 13,
      recipe_id: null,
      sourceUrl: "s3://aible-769303959801-dev-2369/uploads/dev/uploads/tenant_2/98cc6e/raw",
      tenant_id: 2,
      account_id: 2369,
      created_by: {
        id: 18,
        fullname: "Aible Test"
      },
      hasRulefit: false,
      like_count: 0,
      annotations: [
        {
          type: "info",
          scope: "*",
          message:
            "Started Lambda Stack at arn:aws:lambda::us-east-1:validate-headers-0b0b44637f6446f9aa7b6622b3d7f5bc",
          created_date: "2021-08-16T14:00:49"
        },
        {
          type: "info",
          scope: "*",
          message: "Started Lambda Stack at arn:aws:lambda::us-east-1:data-analysis-e25de886007f46d68b48f2a616af13f6",
          created_date: "2021-08-16T14:08:57"
        }
      ],
      permissions: {
        can_edit: true,
        can_view: true,
        can_delete: true,
        can_manage_permissions: true
      },
      status_name: "DONE",
      created_date: "2021-08-16T14:00:37",
      descriptions: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      target_index: 39,
      updated_date: "2021-08-16T14:11:13",
      comment_count: 0,
      dislike_count: 0,
      dataset_status: "DONE",
      number_of_rows: 100000,
      overall_status: ["indexed"],
      transformations: {
        row_filters: []
      },
      schema_monitor_id: null,
      categorical_counts: [
        [
          "Lead_Id",
          [
            ["ID 00100000", 1],
            ["ID 00033350", 1],
            ["ID 00033328", 1],
            ["ID 00033329", 1],
            ["ID 00033330", 1],
            ["ID 00033331", 1],
            ["ID 00033332", 1],
            ["ID 00033333", 1],
            ["ID 00033334", 1],
            ["ID 00033335", 1],
            ["ID 00033336", 1],
            ["ID 00033337", 1],
            ["ID 00033338", 1],
            ["ID 00033339", 1],
            ["ID 00033340", 1],
            ["ID 00033341", 1],
            ["ID 00033342", 1],
            ["ID 00033343", 1],
            ["ID 00033344", 1],
            ["ID 00033345", 1],
            ["ID 00033346", 1],
            ["ID 00033347", 1],
            ["ID 00033348", 1],
            ["ID 00033327", 1],
            ["ID 00033326", 1],
            ["ID 00033325", 1],
            ["ID 00033313", 1],
            ["ID 00033304", 1],
            ["ID 00033305", 1],
            ["ID 00033306", 1],
            ["ID 00033307", 1],
            ["ID 00033308", 1],
            ["ID 00033309", 1],
            ["ID 00033310", 1],
            ["ID 00033311", 1],
            ["ID 00033312", 1],
            ["ID 00033314", 1],
            ["ID 00033324", 1],
            ["ID 00033315", 1],
            ["ID 00033316", 1],
            ["ID 00033317", 1],
            ["ID 00033318", 1],
            ["ID 00033319", 1],
            ["ID 00033320", 1],
            ["ID 00033321", 1],
            ["ID 00033322", 1],
            ["ID 00033323", 1],
            ["ID 00033349", 1],
            ["ID 00033351", 1],
            ["ID 00033302", 1],
            ["{Other}", 99950]
          ]
        ],
        [
          "Age",
          [
            ["Middle Age", 32729],
            ["Senior Citizen", 34058],
            ["Young", 33213]
          ]
        ],
        [
          "Phone_No",
          [
            ["100-009-9999", 1],
            ["100-003-3349", 1],
            ["100-003-3327", 1],
            ["100-003-3328", 1],
            ["100-003-3329", 1],
            ["100-003-3330", 1],
            ["100-003-3331", 1],
            ["100-003-3332", 1],
            ["100-003-3333", 1],
            ["100-003-3334", 1],
            ["100-003-3335", 1],
            ["100-003-3336", 1],
            ["100-003-3337", 1],
            ["100-003-3338", 1],
            ["100-003-3339", 1],
            ["100-003-3340", 1],
            ["100-003-3341", 1],
            ["100-003-3342", 1],
            ["100-003-3343", 1],
            ["100-003-3344", 1],
            ["100-003-3345", 1],
            ["100-003-3346", 1],
            ["100-003-3347", 1],
            ["100-003-3326", 1],
            ["100-003-3325", 1],
            ["100-003-3324", 1],
            ["100-003-3312", 1],
            ["100-003-3303", 1],
            ["100-003-3304", 1],
            ["100-003-3305", 1],
            ["100-003-3306", 1],
            ["100-003-3307", 1],
            ["100-003-3308", 1],
            ["100-003-3309", 1],
            ["100-003-3310", 1],
            ["100-003-3311", 1],
            ["100-003-3313", 1],
            ["100-003-3323", 1],
            ["100-003-3314", 1],
            ["100-003-3315", 1],
            ["100-003-3316", 1],
            ["100-003-3317", 1],
            ["100-003-3318", 1],
            ["100-003-3319", 1],
            ["100-003-3320", 1],
            ["100-003-3321", 1],
            ["100-003-3322", 1],
            ["100-003-3348", 1],
            ["100-003-3350", 1],
            ["100-003-3301", 1],
            ["{Other}", 99950]
          ]
        ],
        [
          "Annual_Income_Bucket",
          [
            ["60k-120k", 33098],
            ["<60k", 32785],
            [">120k", 34117]
          ]
        ],
        [
          "Credit_Score",
          [
            ["350-700", 23915],
            ["<350", 47062],
            [">700", 29023]
          ]
        ],
        [
          "No_Of_Dependents",
          [
            ["0.0", 54152],
            ["1.0", 27154],
            ["2.0", 14072],
            ["3.0", 3661],
            ["{Missing}", 961]
          ]
        ],
        [
          "Ethnicity",
          [
            ["Black", 25242],
            ["Hispanic", 23729],
            ["Other", 22338],
            ["White", 28691]
          ]
        ],
        [
          "Customer_Segment",
          [
            ["Segment 1", 25065],
            ["Segment 2", 24898],
            ["Segment 3", 25263],
            ["Segment 4", 24774]
          ]
        ],
        [
          "Products_with_Bank",
          [
            ["0.0", 37671],
            ["1.0", 11834],
            ["2.0", 27785],
            ["3.0", 21691],
            ["{Missing}", 1019]
          ]
        ],
        [
          "Household_Size",
          [
            ["1.0", 54237],
            ["2.0", 27027],
            ["3.0", 14062],
            ["4.0", 3668],
            ["{Missing}", 1006]
          ]
        ],
        [
          "Gender",
          [
            ["F", 46249],
            ["M", 53751]
          ]
        ],
        [
          "Marital_Status",
          [
            ["D", 25085],
            ["M", 25194],
            ["S", 24936],
            ["W", 24785]
          ]
        ],
        [
          "Time_Of_Day",
          [
            ["Afternoon", 32475],
            ["Evening", 33079],
            ["Morning", 34446]
          ]
        ],
        [
          "Campaign_Id",
          [
            ["2", 19995],
            ["3", 20218],
            ["4", 19721],
            ["5", 19910],
            ["6", 20156]
          ]
        ],
        [
          "Comm_Id",
          [
            ["4", 33260],
            ["5", 33217],
            ["6", 33523]
          ]
        ],
        [
          "Time_Stamp",
          [
            ["2014-03-21T00:00:00.000000Z", 1],
            ["2014-12-31T00:00:00.000000Z", 1]
          ]
        ],
        [
          "Product",
          [
            ["Live Free", 20218],
            ["Live Happy", 20156],
            ["Making Tomorrow Better", 19910],
            ["Protect Your Future", 19995],
            ["Secured Life", 19721]
          ]
        ],
        ["Category", [["Acquisition", 100000]]],
        [
          "Term",
          [
            ["10", 19995],
            ["15", 20218],
            ["16", 20156],
            ["24", 19721],
            ["30", 19910]
          ]
        ],
        [
          "No_Of_People_Covered",
          [
            ["2", 39939],
            ["4", 39905],
            ["5", 20156]
          ]
        ],
        [
          "Premium",
          [
            ["700", 19910],
            ["900", 19721],
            ["1000", 19995],
            ["1500", 20218],
            ["2000", 20156]
          ]
        ],
        [
          "Payment_Frequency",
          [
            ["Monthly", 40213],
            ["Quarterly", 39631],
            ["Yearly", 20156]
          ]
        ],
        [
          "Amt_On_Maturity_Bin",
          [
            ["<200000", 79782],
            ["<400000", 20218]
          ]
        ],
        [
          "Sub_Category",
          [
            ["Branding", 20218],
            ["Penetration", 59787],
            ["Seasonal", 19995]
          ]
        ],
        [
          "Campaign_Drivers",
          [
            ["Additional Coverage", 20218],
            ["Extra benefits", 79782]
          ]
        ],
        [
          "Launch_Date",
          [
            ["2014-03-21T00:00:00.000000Z", 1],
            ["2014-12-05T00:00:00.000000Z", 1]
          ]
        ],
        [
          "Call_For_Action",
          [
            ["0", 39631],
            ["1", 60369]
          ]
        ],
        ["Focused_Geography", [["Nation Wide", 100000]]],
        [
          "Tenure_Of_Campaign",
          [
            ["1", 59934],
            ["2", 40066]
          ]
        ],
        [
          "Net_Amt_Insured",
          [
            ["100000", 39905],
            ["150000", 20156],
            ["200000", 39939]
          ]
        ],
        [
          "Product_Id",
          [
            ["1", 19995],
            ["2", 20218],
            ["4", 19910],
            ["5", 19721],
            ["6", 20156]
          ]
        ],
        [
          "Online_Touchpoints_Count",
          [
            ["0", 11000],
            ["1", 25046],
            ["2", 27763],
            ["3", 21280],
            ["4", 10934],
            ["5", 3421],
            ["6", 556]
          ]
        ],
        [
          "Email_Count",
          [
            ["0", 25813],
            ["1", 34725],
            ["2", 24389],
            ["3", 11123],
            ["4", 3335],
            ["5", 569],
            ["6", 46]
          ]
        ],
        [
          "Tenure",
          [
            ["1", 25776],
            ["3", 29687],
            ["4", 19923],
            ["6", 13381],
            ["7", 7967],
            ["9", 2799],
            ["10", 467]
          ]
        ],
        [
          "Offer",
          [
            ["Home Purchase", 42180],
            ["Refinance Campaign", 42034],
            ["Renovation", 15786]
          ]
        ],
        [
          "Channel",
          [
            ["Digital - Display", 15992],
            ["Digital - Search", 15873],
            ["Direct Mail", 41020],
            ["Email", 27115]
          ]
        ],
        [
          "Region",
          [
            ["Central", 22999],
            ["East", 36252],
            ["West", 40749]
          ]
        ],
        [
          "Campaign_Name",
          [
            ["Campaign A", 19995],
            ["Campaign B", 19910],
            ["Campaign C", 19721],
            ["Campaign D", 20218],
            ["Campaign E", 20156]
          ]
        ],
        [
          "Loan Approved",
          [
            ["No", 90061],
            ["Yes", 9939]
          ]
        ]
      ],
      rulefit_definitions: []
    },
    nextObj: {
      todos: {
        FAIR_GUIDE: {
          x: 10,
          y: 7,
          id: "FAIR_GUIDE",
          text: "Add AI Fairness Guidelines",
          color: "#54C06C",
          index: 0,
          parent: {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                hideSave: true,
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: {
              x: 1,
              y: 0
            },
            oChildDelta: {
              x: 1,
              y: -1
            },
            sectionType: "FAIRNESS"
          },
          actionId: 1,
          afterText: "Fairness guidelines have been defined",
          hasUpdate: true,
          borderColor: "#54C06C",
          isTemporary: false,
          leftSection: "FAIR_GUIDE"
        },
        OPTIMIZE_COSTS: {
          x: 9,
          y: 7,
          id: "OPTIMIZE_COSTS",
          text: "Add Business Costs and Benefits Calculations",
          color: "#7E69D7",
          index: 2,
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: {
              x: 0,
              y: -1
            },
            sectionType: "STRATEGY"
          },
          actionId: 2,
          afterText: "Business costs and benefits have been defined",
          hasUpdate: true,
          isTemporary: false,
          leftSection: "EXPECTED"
        },
        OPTIMIZE_STRATEGY: {
          x: 8,
          y: 8,
          id: "OPTIMIZE_STRATEGY",
          text: "Add Business Strategy Recommendations",
          color: "#7E69D7",
          index: 3,
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: {
              x: 0,
              y: -1
            },
            sectionType: "STRATEGY"
          },
          actionId: 3,
          afterText: "Strategy Updated",
          hasUpdate: true,
          isTemporary: false,
          leftSection: "STRATEGY"
        },
        EVAL_MODEL_DRIVERS: {
          id: "EVAL_MODEL_DRIVERS",
          icon: "Gears",
          text: "Evaluate Model Drivers",
          color: "#7E69D7",
          index: 1,
          parent: {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: {
              x: 0,
              y: 1
            },
            oChildDelta: {
              x: 0,
              y: 1
            },
            sectionType: "DEPLOY"
          },
          actionId: 999,
          hideSave: true,
          hasUpdate: true,
          borderColor: "#247ADF",
          isTemporary: false,
          leftSection: "REVIEW_AI"
        }
      },
      modelsReducer: {
        todos: {
          FAIR_GUIDE: {
            x: 10,
            y: 7,
            id: "FAIR_GUIDE",
            text: "Add AI Fairness Guidelines",
            color: "#54C06C",
            index: 0,
            parent: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  hideSave: true,
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            actionId: 1,
            afterText: "Fairness guidelines have been defined",
            hasUpdate: true,
            borderColor: "#54C06C",
            isTemporary: false,
            leftSection: "FAIR_GUIDE"
          },
          OPTIMIZE_COSTS: {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            index: 2,
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            isTemporary: false,
            leftSection: "EXPECTED"
          },
          OPTIMIZE_STRATEGY: {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 3,
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            isTemporary: false,
            leftSection: "STRATEGY"
          },
          EVAL_MODEL_DRIVERS: {
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 1,
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: {
                x: 0,
                y: 1
              },
              oChildDelta: {
                x: 0,
                y: 1
              },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI"
          }
        },
        hexMap: {
          "7_8": {
            x: 7,
            y: 8,
            id: "DEPLOY",
            icon: "Rocket",
            text: "I want to deploy the current AI",
            color: "#EC6417",
            index: 3,
            selected: {
              0: {
                id: "DEPLOY_REVIEW",
                text: "Review & Approve Deployment Settings",
                borderColor: "#EC6417",
                leftSection: "DEPLOY_SETTINGS"
              },
              1: {
                id: "DEPLOY_INTEGRATION",
                text: "Integrate into your business systems",
                afterText: "Integration has been added",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "INTEGRATE"
              },
              2: {
                id: "DEPLOY_MONITOR",
                text: "Add Monitoring Settings",
                afterText: "Monitoring settings have been updated",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "MONITOR"
              }
            },
            background: "#EC6417",
            childDelta: {
              x: -1,
              y: 1
            },
            oChildDelta: {
              x: -1,
              y: 0
            },
            sectionType: "DEPLOY"
          },
          "8_7": {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: {
              x: 0,
              y: -1
            },
            sectionType: "STRATEGY"
          },
          "8_9": {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: {
              x: 0,
              y: 1
            },
            oChildDelta: {
              x: 0,
              y: 1
            },
            sectionType: "DEPLOY"
          },
          "9_7": {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                hideSave: true,
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: {
              x: 1,
              y: 0
            },
            oChildDelta: {
              x: 1,
              y: -1
            },
            sectionType: "FAIRNESS"
          },
          "9_8": {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                hideSave: true,
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: {
              x: 1,
              y: 1
            },
            oChildDelta: {
              x: 1,
              y: 1
            },
            sectionType: "BUDGET"
          }
        },
        isTodo: true,
        isLoading: false,
        savedHexMap: {
          "7_7": {
            x: 7,
            y: 8,
            icon: "Join",
            text: "Dataset Name",
            color: "#059669",
            isBase: true,
            leftSection: "DATASET"
          },
          "8_5": {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 5,
            author: "Aible Test",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            leftSection: "STRATEGY",
            updatedDate: 1635793757482
          },
          "8_6": {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            index: 4,
            author: "Aible Test",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            leftSection: "EXPECTED",
            updatedDate: 1635793749900
          },
          "8_8": {
            x: 8,
            y: 8,
            icon: "Blueprint",
            text: "Marketing Use Case",
            color: "#7e69d7",
            isBase: true,
            canStart: false,
            selected: {},
            leftSection: "HOME"
          },
          "10_7": {
            x: 10,
            y: 7,
            id: "FAIR_GUIDE",
            text: "Add AI Fairness Guidelines",
            color: "#54C06C",
            index: 2,
            author: "Aible Test",
            parent: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  hideSave: true,
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            actionId: 1,
            afterText: "Fairness guidelines have been defined",
            hasUpdate: true,
            borderColor: "#54C06C",
            leftSection: "FAIR_GUIDE",
            updatedDate: 1635793738446
          },
          "8_10": {
            x: 8,
            y: 10,
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 3,
            author: "Aible Test",
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: {
                x: 0,
                y: 1
              },
              oChildDelta: {
                x: 0,
                y: 1
              },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI",
            updatedDate: 1635793738447
          }
        },
        actionHexMap: {},
        savedActions: [
          {
            n: {
              x: 9,
              y: 7,
              id: "FAIR",
              icon: "Fairness",
              text: "I want to add fairness goals and guidelines",
              color: "#54C06C",
              index: 1,
              selected: {
                0: {
                  id: "FAIR_VALUE",
                  text: "What Subgroup Do you want to Optimize for?",
                  hideSave: true,
                  afterText: "Subgroup focus: undefined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "SUBGROUP"
                },
                1: {
                  id: "FAIR_GUIDE",
                  text: "Add AI Fairness Guidelines",
                  afterText: "Fairness guidelines have been defined",
                  hasUpdate: true,
                  borderColor: "#54C06C",
                  leftSection: "FAIR_GUIDE"
                }
              },
              background: "#54C06C",
              childDelta: {
                x: 1,
                y: 0
              },
              oChildDelta: {
                x: 1,
                y: -1
              },
              sectionType: "FAIRNESS"
            },
            hex: {
              x: 9,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            hex: {
              x: 8,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: {
                x: 0,
                y: -1
              },
              sectionType: "STRATEGY"
            },
            hex: {
              x: 8,
              y: 7
            },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            type: "HANDLE_BACK",
            isVisible: false
          }
        ]
      }
    },
    sensitive: {},
    customFields: {
      Review_Cost: {
        id: "Review_Cost",
        desc: ""
      },
      Average_Loan: {
        id: "Average_Loan",
        desc: ""
      },
      Closing_Fees: {
        id: "Closing_Fees",
        desc: ""
      },
      Servicing_Cost: {
        id: "Servicing_Cost",
        desc: ""
      },
      Loan_Margin_Percent: {
        id: "Loan_Margin_Percent",
        desc: ""
      }
    },
    advancedInputs: {
      advancedCost: "Review_Cost",
      trueNegative: "0",
      truePositive: "Average_Loan*Loan_Margin_Percent/100+Closing_Fees-Review_Cost-Servicing_Cost",
      falseNegative: "0",
      falsePositive: "-Review_Cost",
      advancedRevenue: "Average_Loan*Loan_Margin_Percent/100+Closing_Fees"
    }
  }
};

const HOSPITAL_READMISSION = {
  ...DEFAULT_USE_CASE_SETTINGS,
  outcome_behavior: "MAXIMIZE",
  id: "HOSPITAL_READMISSION",
  name: "Hospital Readmission",
  suggested_fields: [],
  wizard: {
    setup: {
      goal: "Maximize",
      mode: 2,
      label: "Hospital Readmission",
      total: 20000,
      models: [],
      ignored: {},
      success: { count: 19684, label: "Yes", value: "Yes" },
      useCase: "Sales Prediction",
      aimToHit: 800,
      endState: [],
      targeted: 2000,
      unitType: "$",
      auditable: false,
      datasetId: "1",
      hideCosts: false,
      threshold: [0, 0],
      contAction: "Sell",
      errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
      fieldTypes: {},
      isQuickRun: false,
      timePeriod: "Month",
      trueAction: "Not Discharge",
      falseAction: "Release",
      isBlueprint: true,
      splitColumn: "Admission Type Id",
      advancedCost: -4000,
      customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
      fieldReplace: {},
      modelOptions: [],
      outcomeLabel: "Readmission",
      processLimit: 0,
      showBusiness: true,
      trueNegative: 0,
      truePositive: 19684,
      advancedInput: {},
      biasReduction: "Impact",
      falseNegative: 0,
      falsePositive: 36448,
      ignoredModels: {},
      conversionCost: -4000,
      conversionGain: 5000,
      conversionRate: 5,
      customMappings: {},
      netImpactLabel: "Impact",
      advancedRevenue: 9000,
      conversionSaved: 0,
      numberPredicted: "Price",
      realTimeResults: false,
      aiTrainingBudget: 200,
      conversionMissed: -5000,
      hasLinkedProject: false,
      isForceOptimized: false,
      transactionLabel: "Patients",
      advancedCostLabel: "Holding Cost",
      businessObjective: "Profit",
      fairnessObjective: "None",
      overPredictAction: "Overestimate Loss",
      overestimateLabel: "Overestimate",
      trueNegativeLabel: "Correctly Discharged",
      truePositiveLabel: "Correctly Held",
      falseNegativeLabel: "Incorrectly Discharged",
      falsePositiveLabel: "Incorrectly Held",
      underPredictAction: "Underestimate Loss",
      underestimateLabel: "Underestimate",
      academicResultsStep: 0,
      humanUnderstandable: false,
      advancedRevenueLabel: "Holding Revenue",
      baselineCustomValues: {},
      maximumConversionRate: 5,
      fairnessToleranceBound: 1,
      notPursuedTransactionLabel: "Patients"
    },
    dataset: {
      id: "HOSPITAL_READMISSION",
      name: "Berkeley Real World AI Challenge Train Adjusted.csv",
      tags: [],
      label: "Berkeley Real World AI Challenge Train Adjusted.csv",
      errors: [],
      fields: {
        Race: { type: "categorical", label: "Race" },
        "Diag 1": { type: "categorical", label: "Diag 1" },
        "Diag 2": { type: "categorical", label: "Diag 2" },
        "Diag 3": { type: "categorical", label: "Diag 3" },
        Gender: { type: "categorical", label: "Gender" },
        "Age Bin": { type: "categorical", label: "Age Bin" },
        "Medicine 1": { type: "categorical", label: "Medicine 1" },
        "Medicine 2": { type: "categorical", label: "Medicine 2" },
        "Medicine 3": { type: "categorical", label: "Medicine 3" },
        "Medicine 4": { type: "categorical", label: "Medicine 4" },
        "Medicine 5": { type: "categorical", label: "Medicine 5" },
        "Medicine 6": { type: "categorical", label: "Medicine 6" },
        "Medicine 7": { type: "categorical", label: "Medicine 7" },
        "Medicine 8": { type: "categorical", label: "Medicine 8" },
        "Medicine 9": { type: "categorical", label: "Medicine 9" },
        "Payer Code": { type: "categorical", label: "Payer Code" },
        Readmitted: { type: "categorical", label: "Readmitted" },
        "Weight Bin": { type: "categorical", label: "Weight Bin" },
        "Medicine 10": { type: "categorical", label: "Medicine 10" },
        "Medicine 11": { type: "categorical", label: "Medicine 11" },
        "Medicine 12": { type: "categorical", label: "Medicine 12" },
        "Medicine 13": { type: "categorical", label: "Medicine 13" },
        "Medicine 14": { type: "categorical", label: "Medicine 14" },
        "Medicine 15": { type: "categorical", label: "Medicine 15" },
        "Medicine 16": { type: "categorical", label: "Medicine 16" },
        "Patient Nbr": { type: "categorical", label: "Patient Nbr" },
        "Encounter Id": { type: "categorical", label: "Encounter Id" },
        "Test 1 Result": { type: "categorical", label: "Test 1 Result" },
        "Test 2 Result": { type: "categorical", label: "Test 2 Result" },
        "Medicine 1 & 7": { type: "categorical", label: "Medicine 1 & 7" },
        "Num Procedures": { type: "categorical", label: "Num Procedures" },
        "Medicine 1 & 10": { type: "categorical", label: "Medicine 1 & 10" },
        "Medicine 1 & 11": { type: "categorical", label: "Medicine 1 & 11" },
        "Medicine 1 & 17": { type: "categorical", label: "Medicine 1 & 17" },
        "Medicine 5 & 10": { type: "categorical", label: "Medicine 5 & 10" },
        "Num Medications": { type: "number", label: "Num Medications" },
        "Number Diagnoses": { type: "categorical", label: "Number Diagnoses" },
        "Number Emergency": { type: "number", label: "Number Emergency" },
        "Number Inpatient": { type: "categorical", label: "Number Inpatient" },
        "Time In Hospital": { type: "categorical", label: "Time In Hospital" },
        "Admission Type Id": { type: "categorical", label: "Admission Type Id" },
        "Medical Specialty": { type: "categorical", label: "Medical Specialty" },
        "Number Outpatient": { type: "number", label: "Number Outpatient" },
        "Num Lab Procedures": { type: "number", label: "Num Lab Procedures" },
        "Admission Source Id": { type: "categorical", label: "Admission Source Id" },
        "Change of Medication": { type: "categorical", label: "Change of Medication" },
        "Medication Prescribed": { type: "categorical", label: "Medication Prescribed" },
        "Discharge Disposition Id": { type: "categorical", label: "Discharge Disposition Id" }
      },
      labels: [
        "Encounter Id",
        "Patient Nbr",
        "Race",
        "Gender",
        "Age Bin",
        "Weight Bin",
        "Admission Type Id",
        "Discharge Disposition Id",
        "Admission Source Id",
        "Time In Hospital",
        "Payer Code",
        "Medical Specialty",
        "Num Lab Procedures",
        "Num Procedures",
        "Num Medications",
        "Number Outpatient",
        "Number Emergency",
        "Number Inpatient",
        "Diag 1",
        "Diag 2",
        "Diag 3",
        "Number Diagnoses",
        "Test 1 Result",
        "Test 2 Result",
        "Medicine 1",
        "Medicine 2",
        "Medicine 3",
        "Medicine 4",
        "Medicine 5",
        "Medicine 6",
        "Medicine 7",
        "Medicine 8",
        "Medicine 9",
        "Medicine 10",
        "Medicine 11",
        "Medicine 12",
        "Medicine 13",
        "Medicine 14",
        "Medicine 15",
        "Medicine 16",
        "Medicine 1 & 17",
        "Medicine 1 & 7",
        "Medicine 5 & 10",
        "Medicine 1 & 11",
        "Medicine 1 & 10",
        "Change of Medication",
        "Medication Prescribed",
        "Readmitted"
      ],
      source: {
        url: "s3://aible-769303959801-proto-hackathon-21/uploads/proto-hackathon/uploads/tenant_12/f43e05/raw",
        type: {
          id: 1,
          status: "ACTIVE",
          pattern: "s3:\\/\\/([^/]+)(?=\\/)\\/?(.*)",
          service_name: "S3",
          provider_name: "Amazon"
        },
        content: { type: "RAW_DATA" }
      },
      status: ["indexed"],
      target: "Readmitted",
      created: "2021-11-02T21:47:03",
      deleted: false,
      outcome: "Readmitted",
      ratings: [],
      comments: [],
      feedback: "NONE",
      rowCount: 56132,
      stack_id: null,
      warnings: [
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Encounter Id",
            message: "Column 'Encounter Id' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:36"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Patient Nbr",
            message: "Column 'Patient Nbr' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:37"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Number Emergency",
            message: "Column 'Number Emergency' has too few observed values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:37"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Number Inpatient",
            message: "Column 'Number Inpatient' has too many missing values  It would be discarded."
          },
          created_date: "2021-11-02T21:47:37"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Medicine 6",
            message: "Column 'Medicine 6' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:38"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Medicine 14",
            message: "Column 'Medicine 14' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:38"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Medicine 5 & 10",
            message: "Column 'Medicine 5 & 10' has only one unique value.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:38"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Medicine 1 & 11",
            message: "Column 'Medicine 1 & 11' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:39"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Medicine 1 & 10",
            message: "Column 'Medicine 1 & 10' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-11-02T21:47:39"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Race has 1508 missing values out of 56132 total values, comprising 2.69 % of the data in this column.",
          metadata: {
            column: "Race",
            percentage: 2.686524620537305,
            num_missing: 1508,
            num_observed: 54624,
            unique_message:
              " Column Race has 1508 missing values out of 56132 total values, comprising 2.69 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:39"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Weight Bin has 53926 missing values out of 56132 total values, comprising 96.07 % of the data in this column.",
          metadata: {
            column: "Weight Bin",
            percentage: 96.06997790921399,
            num_missing: 53926,
            num_observed: 2206,
            unique_message:
              " Column Weight Bin has 53926 missing values out of 56132 total values, comprising 96.07 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:40"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Discharge Disposition Id has 54295 missing values out of 56132 total values, comprising 96.73 % of the data in this column.",
          metadata: {
            column: "Discharge Disposition Id",
            percentage: 96.72735694434547,
            num_missing: 54295,
            num_observed: 1837,
            unique_message:
              " Column Discharge Disposition Id has 54295 missing values out of 56132 total values, comprising 96.73 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:40"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Admission Source Id has 52185 missing values out of 56132 total values, comprising 92.97 % of the data in this column.",
          metadata: {
            column: "Admission Source Id",
            percentage: 92.96836029359368,
            num_missing: 52185,
            num_observed: 3947,
            unique_message:
              " Column Admission Source Id has 52185 missing values out of 56132 total values, comprising 92.97 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:40"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Time In Hospital has 51999 missing values out of 56132 total values, comprising 92.64 % of the data in this column.",
          metadata: {
            column: "Time In Hospital",
            percentage: 92.6369985035274,
            num_missing: 51999,
            num_observed: 4133,
            unique_message:
              " Column Time In Hospital has 51999 missing values out of 56132 total values, comprising 92.64 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:41"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Payer Code has 24149 missing values out of 56132 total values, comprising 43.02 % of the data in this column.",
          metadata: {
            column: "Payer Code",
            percentage: 43.02180574360436,
            num_missing: 24149,
            num_observed: 31983,
            unique_message:
              " Column Payer Code has 24149 missing values out of 56132 total values, comprising 43.02 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:41"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Medical Specialty has 27078 missing values out of 56132 total values, comprising 48.24 % of the data in this column.",
          metadata: {
            column: "Medical Specialty",
            percentage: 48.23986317964797,
            num_missing: 27078,
            num_observed: 29054,
            unique_message:
              " Column Medical Specialty has 27078 missing values out of 56132 total values, comprising 48.24 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:41"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Num Lab Procedures has 4232 missing values out of 56132 total values, comprising 7.54 % of the data in this column.",
          metadata: {
            column: "Num Lab Procedures",
            percentage: 7.5393714815078745,
            num_missing: 4232,
            num_observed: 51900,
            unique_message:
              " Column Num Lab Procedures has 4232 missing values out of 56132 total values, comprising 7.54 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:42"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Num Medications has 12343 missing values out of 56132 total values, comprising 21.99 % of the data in this column.",
          metadata: {
            column: "Num Medications",
            percentage: 21.98923964939785,
            num_missing: 12343,
            num_observed: 43789,
            unique_message:
              " Column Num Medications has 12343 missing values out of 56132 total values, comprising 21.99 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:42"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Number Outpatient has 56026 missing values out of 56132 total values, comprising 99.81 % of the data in this column.",
          metadata: {
            column: "Number Outpatient",
            percentage: 99.81115940996223,
            num_missing: 56026,
            num_observed: 106,
            unique_message:
              " Column Number Outpatient has 56026 missing values out of 56132 total values, comprising 99.81 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:42"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Diag 1 has 290 missing values out of 56132 total values, comprising 0.52 % of the data in this column.",
          metadata: {
            column: "Diag 1",
            percentage: 0.5166393501033278,
            num_missing: 290,
            num_observed: 55842,
            unique_message:
              " Column Diag 1 has 290 missing values out of 56132 total values, comprising 0.52 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:42"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Diag 2 has 321 missing values out of 56132 total values, comprising 0.57 % of the data in this column.",
          metadata: {
            column: "Diag 2",
            percentage: 0.5718663151143732,
            num_missing: 321,
            num_observed: 55811,
            unique_message:
              " Column Diag 2 has 321 missing values out of 56132 total values, comprising 0.57 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:43"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Diag 3 has 1053 missing values out of 56132 total values, comprising 1.88 % of the data in this column.",
          metadata: {
            column: "Diag 3",
            percentage: 1.875935295375187,
            num_missing: 1053,
            num_observed: 55079,
            unique_message:
              " Column Diag 3 has 1053 missing values out of 56132 total values, comprising 1.88 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:43"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Number Diagnoses has 56070 missing values out of 56132 total values, comprising 99.89 % of the data in this column.",
          metadata: {
            column: "Number Diagnoses",
            percentage: 99.88954606997791,
            num_missing: 56070,
            num_observed: 62,
            unique_message:
              " Column Number Diagnoses has 56070 missing values out of 56132 total values, comprising 99.89 % of the data in this column."
          },
          created_date: "2021-11-02T21:47:43"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Encounter Id",
            message:
              "Encounter Id has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-11-02T21:47:44"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Patient Nbr",
            message:
              "Patient Nbr has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-11-02T21:47:44"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Medical Specialty",
            message:
              "Medical Specialty has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-11-02T21:47:44"
        }
      ],
      accountId: 21,
      file_size: 11,
      folder_id: 3,
      recipe_id: null,
      sourceUrl: "s3://aible-769303959801-proto-hackathon-21/uploads/proto-hackathon/uploads/tenant_12/f43e05/raw",
      tenant_id: 12,
      account_id: 21,
      created_by: { id: 10, fullname: "Aible Admin" },
      hasRulefit: false,
      like_count: 0,
      annotations: [
        {
          type: "info",
          scope: "*",
          message:
            "Started Lambda Stack at arn:aws:lambda::us-east-1:validate-headers-74dc7b79bc384c6e8f7130808e0d8bc3",
          created_date: "2021-11-02T21:47:04"
        },
        {
          type: "info",
          scope: "*",
          message: "Started Lambda Stack at arn:aws:lambda::us-east-1:data-analysis-08e31de30e2c49d4b869fc7f7c5cf787",
          created_date: "2021-11-02T21:48:37"
        }
      ],
      permissions: {
        can_edit: true,
        can_view: true,
        can_delete: true,
        can_give_feedback: true,
        can_manage_permissions: true
      },
      status_name: "DONE",
      created_date: "2021-11-02T21:47:03",
      descriptions: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      target_index: 47,
      updated_date: "2021-11-02T21:50:05",
      comment_count: 0,
      dislike_count: 0,
      dataset_status: "DONE",
      number_of_rows: 56132,
      overall_status: ["indexed"],
      transformations: { row_filters: [] },
      schema_monitor_id: null,
      categorical_counts: [
        [
          "Encounter Id",
          [
            ["A99992796", 1],
            ["A175555458", 1],
            ["A175570152", 1],
            ["A175569918", 1],
            ["A175569234", 1],
            ["A175568940", 1],
            ["A175566960", 1],
            ["A175563750", 1],
            ["A175563456", 1],
            ["A175560966", 1],
            ["A175560660", 1],
            ["A175558728", 1],
            ["A175557804", 1],
            ["A175554114", 1],
            ["A175454394", 1],
            ["A175548162", 1],
            ["A175547802", 1],
            ["A175547376", 1],
            ["A175547358", 1],
            ["A175544250", 1],
            ["A175531368", 1],
            ["A175530354", 1],
            ["A175519176", 1],
            ["A175513662", 1],
            ["A175477782", 1],
            ["A175474644", 1],
            ["A175573200", 1],
            ["A175573836", 1],
            ["A175578384", 1],
            ["A175581120", 1],
            ["A175626516", 1],
            ["A175625958", 1],
            ["A175624794", 1],
            ["A175622922", 1],
            ["A175622574", 1],
            ["A175621740", 1],
            ["A175621302", 1],
            ["A175621230", 1],
            ["A175620432", 1],
            ["A175619928", 1],
            ["A175619274", 1],
            ["A175617900", 1],
            ["A175614036", 1],
            ["A175613916", 1],
            ["A175613904", 1],
            ["A175611822", 1],
            ["A175610682", 1],
            ["A175601526", 1],
            ["A175590156", 1],
            ["A175589826", 1],
            ["{Other}", 56082]
          ]
        ],
        [
          "Patient Nbr",
          [
            ["A99998208", 1],
            ["A25032573", 1],
            ["A25037820", 1],
            ["A25037244", 1],
            ["A250362", 1],
            ["A25035957", 1],
            ["A25035732", 1],
            ["A2503566", 1],
            ["A25035516", 1],
            ["A25034670", 1],
            ["A25034454", 1],
            ["A25034400", 1],
            ["A25033500", 1],
            ["A2503233", 1],
            ["A25025040", 1],
            ["A25032204", 1],
            ["A25031520", 1],
            ["A25031088", 1],
            ["A25030917", 1],
            ["A25030719", 1],
            ["A25030197", 1],
            ["A25029891", 1],
            ["A25029126", 1],
            ["A25028028", 1],
            ["A25027605", 1],
            ["A25027281", 1],
            ["A25038216", 1],
            ["A25038225", 1],
            ["A25038333", 1],
            ["A25038522", 1],
            ["A25045380", 1],
            ["A25044903", 1],
            ["A25044840", 1],
            ["A2504466", 1],
            ["A25044507", 1],
            ["A25043463", 1],
            ["A25042896", 1],
            ["A25042419", 1],
            ["A25042383", 1],
            ["A25042275", 1],
            ["A25041996", 1],
            ["A25041393", 1],
            ["A25041087", 1],
            ["A25040448", 1],
            ["A25040394", 1],
            ["A25040313", 1],
            ["A25039836", 1],
            ["A25039809", 1],
            ["A25039467", 1],
            ["A25039341", 1],
            ["{Other}", 56082]
          ]
        ],
        [
          "Race",
          [
            ["AfricanAmerican", 10096],
            ["Asian", 389],
            ["Caucasian", 42004],
            ["Hispanic", 1218],
            ["Other", 917],
            ["{Missing}", 1508]
          ]
        ],
        [
          "Gender",
          [
            ["Female", 29838],
            ["Male", 26292],
            ["Unknown/Invalid", 2]
          ]
        ],
        [
          "Age Bin",
          [
            ["[0-10)", 124],
            ["[10-20)", 423],
            ["[20-30)", 928],
            ["[30-40)", 2152],
            ["[40-50)", 5418],
            ["[50-60)", 9876],
            ["[60-70)", 12544],
            ["[70-80)", 14215],
            ["[80-90)", 9026],
            ["[90-100)", 1426]
          ]
        ],
        [
          "Weight Bin",
          [
            [">200", 2],
            ["[0-25)", 38],
            ["[100-125)", 410],
            ["[125-150)", 97],
            ["[150-175)", 25],
            ["[175-200)", 7],
            ["[25-50)", 74],
            ["[50-75)", 613],
            ["[75-100)", 940],
            ["{Missing}", 53926]
          ]
        ],
        [
          "Admission Type Id",
          [
            ["Elective", 11004],
            ["Emergency", 28683],
            ["Other", 6114],
            ["Urgent", 10331]
          ]
        ],
        [
          "Discharge Disposition Id",
          [
            ["Discharged/transferred to a federal health care facility.", 3],
            ["Discharged/transferred to a long term care hospital.", 212],
            [
              "Discharged/transferred to a nursing facility certified under Medicaid but not certified under Medicare.",
              20
            ],
            ["Discharged/transferred to another rehab fac including rehab units of a hospital .", 1046],
            ["Discharged/transferred within this institution to Medicare approved swing bed", 28],
            ["Discharged/transferred/referred another institution for outpatient services", 3],
            [
              "Discharged/transferred/referred to a psychiatric hospital of psychiatric distinct part unit of a hospital",
              69
            ],
            ["Discharged/transferred/referred to this institution for outpatient services", 8],
            ["Hospice / home", 231],
            ["Hospice / medical facility", 210],
            ["Neonate discharged to another hospital for neonatal aftercare", 5],
            ["Still patient or expected to return for outpatient services", 2],
            ["{Missing}", 54295]
          ]
        ],
        [
          "Admission Source Id",
          [
            ["0", 3933],
            ["Extramural Birth", 1],
            ["Normal Delivery", 1],
            ["Sick Baby", 1],
            ["Transfer from Ambulatory Surgery Center", 1],
            ["Transfer from critial access hospital", 6],
            ["Transfer from hospital inpt/same fac reslt in a sep claim", 4],
            ["{Missing}", 52185]
          ]
        ],
        [
          "Time In Hospital",
          [
            ["10.0", 1220],
            ["11.0", 980],
            ["12.0", 751],
            ["13.0", 636],
            ["14.0", 546],
            ["{Missing}", 51999]
          ]
        ],
        [
          "Payer Code",
          [
            ["BC", 2701],
            ["CH", 89],
            ["CM", 1079],
            ["CP", 1533],
            ["DM", 304],
            ["FR", 1],
            ["HM", 3215],
            ["MC", 16175],
            ["MD", 1719],
            ["MP", 32],
            ["OG", 508],
            ["OT", 49],
            ["PO", 371],
            ["SI", 33],
            ["SP", 2609],
            ["UN", 1469],
            ["WC", 96],
            ["{Missing}", 24149]
          ]
        ],
        [
          "Medical Specialty",
          [
            ["InternalMedicine", 8562],
            ["Family/GeneralPractice", 3937],
            ["Emergency/Trauma", 3509],
            ["Cardiology", 3311],
            ["Surgery-General", 1780],
            ["Orthopedics", 877],
            ["Orthopedics-Reconstructive", 833],
            ["Nephrology", 676],
            ["Radiologist", 672],
            ["Psychiatry", 511],
            ["Pulmonology", 506],
            ["ObstetricsandGynecology", 465],
            ["Urology", 411],
            ["Surgery-Cardiovascular/Thoracic", 395],
            ["Surgery-Neuro", 314],
            ["Gastroenterology", 303],
            ["Surgery-Vascular", 287],
            ["PhysicalMedicineandRehabilitation", 185],
            ["Oncology", 163],
            ["Pediatrics", 160],
            ["Neurology", 128],
            ["Pediatrics-Endocrinology", 113],
            ["Hematology/Oncology", 90],
            ["Endocrinology", 80],
            ["Otolaryngology", 78],
            ["Surgery-Cardiovascular", 71],
            ["Surgery-Thoracic", 71],
            ["Pediatrics-CriticalCare", 59],
            ["Psychology", 44],
            ["Podiatry", 41],
            ["Gynecology", 39],
            ["Hospitalist", 31],
            ["Radiology", 29],
            ["Surgeon", 29],
            ["Surgery-Plastic", 29],
            ["Ophthalmology", 28],
            ["Osteopath", 27],
            ["Hematology", 25],
            ["InfectiousDiseases", 21],
            ["SurgicalSpecialty", 21],
            ["Obstetrics", 18],
            ["Obsterics&Gynecology-GynecologicOnco", 16],
            ["Rheumatology", 12],
            ["Anesthesiology-Pediatric", 11],
            ["Anesthesiology", 8],
            ["Surgery-Maxillofacial", 7],
            ["Surgery-Colon&Rectal", 7],
            ["Pathology", 6],
            ["PhysicianNotFound", 6],
            ["Pediatrics-Pulmonology", 5],
            ["{Other}", 47],
            ["{Missing}", 27078]
          ]
        ],
        [
          "Num Procedures",
          [
            ["0", 24904],
            ["1", 11375],
            ["2", 7228],
            ["3", 5483],
            ["4", 2338],
            ["5", 1874],
            ["6", 2930]
          ]
        ],
        [
          "Number Inpatient",
          [
            ["10.0", 7],
            ["11.0", 4],
            ["12.0", 3],
            ["17.0", 1],
            ["{Missing}", 56117]
          ]
        ],
        [
          "Diag 1",
          [
            ["Circulatory", 16912],
            ["Diabetes", 4452],
            ["Digestive", 5235],
            ["Genitourinary", 2843],
            ["Injury", 3816],
            ["Musculoskeletal", 3193],
            ["Neoplasms", 2130],
            ["Other", 9738],
            ["Respiratory", 7523],
            ["{Missing}", 290]
          ]
        ],
        [
          "Diag 2",
          [
            ["Circulatory", 17542],
            ["Diabetes", 3646],
            ["Digestive", 2315],
            ["Genitourinary", 4391],
            ["Injury", 1499],
            ["Musculoskeletal", 1042],
            ["Neoplasms", 1380],
            ["Other", 18348],
            ["Respiratory", 5648],
            ["{Missing}", 321]
          ]
        ],
        [
          "Diag 3",
          [
            ["Circulatory", 16661],
            ["Diabetes", 2814],
            ["Digestive", 2136],
            ["Genitourinary", 3339],
            ["Injury", 1153],
            ["Musculoskeletal", 1120],
            ["Neoplasms", 998],
            ["Other", 23119],
            ["Respiratory", 3739],
            ["{Missing}", 1053]
          ]
        ],
        [
          "Number Diagnoses",
          [
            ["10.0", 8],
            ["11.0", 5],
            ["12.0", 3],
            ["13.0", 12],
            ["14.0", 5],
            ["15.0", 4],
            ["16.0", 25],
            ["{Missing}", 56070]
          ]
        ],
        [
          "Test 1 Result",
          [
            [">200", 739],
            [">300", 569],
            ["None", 53441],
            ["Norm", 1383]
          ]
        ],
        [
          "Test 2 Result",
          [
            [">7", 2206],
            [">8", 4857],
            ["None", 46093],
            ["Norm", 2976]
          ]
        ],
        [
          "Medicine 1",
          [
            ["Down", 340],
            ["No", 44393],
            ["Steady", 10768],
            ["Up", 631]
          ]
        ],
        [
          "Medicine 2",
          [
            ["Down", 26],
            ["No", 55379],
            ["Steady", 658],
            ["Up", 69]
          ]
        ],
        [
          "Medicine 3",
          [
            ["Down", 8],
            ["No", 55736],
            ["Steady", 375],
            ["Up", 13]
          ]
        ],
        [
          "Medicine 4",
          [
            ["No", 56075],
            ["Steady", 55],
            ["Up", 2]
          ]
        ],
        [
          "Medicine 5",
          [
            ["Down", 117],
            ["No", 53200],
            ["Steady", 2634],
            ["Up", 181]
          ]
        ],
        [
          "Medicine 6",
          [
            ["No", 56131],
            ["Steady", 1]
          ]
        ],
        [
          "Medicine 7",
          [
            ["Down", 267],
            ["No", 49012],
            ["Steady", 6402],
            ["Up", 451]
          ]
        ],
        [
          "Medicine 8",
          [
            ["Down", 326],
            ["No", 49988],
            ["Steady", 5361],
            ["Up", 457]
          ]
        ],
        [
          "Medicine 9",
          [
            ["No", 56119],
            ["Steady", 13]
          ]
        ],
        [
          "Medicine 10",
          [
            ["Down", 60],
            ["No", 51970],
            ["Steady", 3960],
            ["Up", 142]
          ]
        ],
        [
          "Medicine 11",
          [
            ["Down", 59],
            ["No", 52463],
            ["Steady", 3506],
            ["Up", 104]
          ]
        ],
        [
          "Medicine 12",
          [
            ["Down", 1],
            ["No", 55984],
            ["Steady", 139],
            ["Up", 8]
          ]
        ],
        [
          "Medicine 13",
          [
            ["No", 56116],
            ["Steady", 16]
          ]
        ],
        [
          "Medicine 14",
          [
            ["No", 56131],
            ["Steady", 1]
          ]
        ],
        [
          "Medicine 15",
          [
            ["No", 56112],
            ["Steady", 20]
          ]
        ],
        [
          "Medicine 16",
          [
            ["Down", 5993],
            ["No", 27259],
            ["Steady", 17390],
            ["Up", 5490]
          ]
        ],
        [
          "Medicine 1 & 17",
          [
            ["Down", 3],
            ["No", 55734],
            ["Steady", 387],
            ["Up", 8]
          ]
        ],
        [
          "Medicine 1 & 7",
          [
            ["No", 56129],
            ["Steady", 3]
          ]
        ],
        ["Medicine 5 & 10", [["No", 56132]]],
        [
          "Medicine 1 & 11",
          [
            ["No", 56131],
            ["Steady", 1]
          ]
        ],
        [
          "Medicine 1 & 10",
          [
            ["No", 56131],
            ["Steady", 1]
          ]
        ],
        [
          "Change of Medication",
          [
            ["Ch", 25233],
            ["No", 30899]
          ]
        ],
        [
          "Medication Prescribed",
          [
            ["No", 13368],
            ["Yes", 42764]
          ]
        ],
        [
          "Readmitted",
          [
            ["No", 36448],
            ["Yes", 19684]
          ]
        ]
      ],
      interaction_scores: {
        "Race:Race": 0.05633601436460034,
        "Diag 1:Diag 1": 0.07054556556985243,
        "Diag 3:Diag 3": 0.0713478619827698,
        "Age Bin:Age Bin": 0.1183354525673644,
        "Medicine 1:Medicine 1": 0.1384854201152516,
        "Payer Code:Payer Code": 0.11858757159219244,
        "Weight Bin:Weight Bin": 0.14091172566693935,
        "Medicine 16:Medicine 16": 0.0724932045853707,
        "Test 2 Result:Test 2 Result": 0.09433711837764715,
        "Num Medications:Num Medications": 0.06295260250801576,
        "Discharge Disposition Id:Age Bin": 0.02540961798555606,
        "Admission Type Id:Admission Type Id": 0.13723224267552284,
        "Medical Specialty:Medical Specialty": 0.18160719939828537,
        "Number Outpatient:Number Outpatient": 0.059028521901484034,
        "Num Lab Procedures:Num Lab Procedures": 0.14414896620116782,
        "Medication Prescribed:Medication Prescribed": 0.2725276644299577,
        "Discharge Disposition Id:Discharge Disposition Id": 1
      },
      rulefit_definitions: []
    },
    nextObj: {
      todos: {
        BUDGET_SUBGROUP: {
          x: 9,
          y: 7,
          id: "BUDGET_SUBGROUP",
          text: "Select Subgroup",
          color: "#00B5D0",
          index: 6,
          author: "Aible Admin",
          parent: {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                hideSave: true,
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: { x: 1, y: 1 },
            oChildDelta: { x: 1, y: 1 },
            sectionType: "BUDGET"
          },
          actionId: 0,
          hideSave: true,
          afterText: "Subgroup focus: Admission Type Id",
          hasUpdate: true,
          setupStep: {},
          afterSetup: {
            goal: "Maximize",
            mode: 2,
            label: "",
            total: 20000,
            models: [],
            ignored: {},
            success: { count: 36448, label: "No", value: "No" },
            useCase: "Sales Prediction",
            aimToHit: 800,
            endState: [],
            targeted: 2000,
            unitType: "$",
            auditable: false,
            datasetId: "1",
            hideCosts: false,
            threshold: [0, 0],
            contAction: "Sell",
            errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
            fieldTypes: {},
            isQuickRun: false,
            timePeriod: "Month",
            trueAction: "Not Discharge",
            falseAction: "Release",
            isBlueprint: true,
            splitColumn: "Admission Type Id",
            advancedCost: -4000,
            customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
            fieldReplace: {},
            modelOptions: [],
            outcomeLabel: "Readmission",
            processLimit: 0,
            showBusiness: true,
            trueNegative: 0,
            truePositive: 36448,
            advancedInput: {},
            biasReduction: "Impact",
            falseNegative: 0,
            falsePositive: 19684,
            ignoredModels: {},
            conversionCost: -4000,
            conversionGain: 5000,
            conversionRate: 5,
            customMappings: {},
            netImpactLabel: "Impact",
            advancedRevenue: 9000,
            conversionSaved: 0,
            numberPredicted: "Price",
            realTimeResults: false,
            aiTrainingBudget: 200,
            conversionMissed: -5000,
            hasLinkedProject: false,
            isForceOptimized: false,
            transactionLabel: "Patients",
            advancedCostLabel: "Holding Cost",
            businessObjective: "Profit",
            fairnessObjective: "None",
            overPredictAction: "Overestimate Loss",
            overestimateLabel: "Overestimate",
            trueNegativeLabel: "Correctly Discharged",
            truePositiveLabel: "Correctly Held",
            falseNegativeLabel: "Incorrectly Discharged",
            falsePositiveLabel: "Incorrectly Held",
            underPredictAction: "Underestimate Loss",
            underestimateLabel: "Underestimate",
            academicResultsStep: 0,
            humanUnderstandable: false,
            advancedRevenueLabel: "Holding Revenue",
            baselineCustomValues: {},
            maximumConversionRate: 5,
            fairnessToleranceBound: 1,
            notPursuedTransactionLabel: "Patients"
          },
          borderColor: "#00B5D0",
          leftSection: "SUBGROUP",
          updatedDate: 1635891682555
        },
        EVAL_MODEL_DRIVERS: {
          id: "EVAL_MODEL_DRIVERS",
          icon: "Gears",
          text: "Evaluate Model Drivers",
          color: "#7E69D7",
          index: 1,
          parent: {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: { x: 0, y: 1 },
            oChildDelta: { x: 0, y: 1 },
            sectionType: "DEPLOY"
          },
          actionId: 999,
          hideSave: true,
          hasUpdate: true,
          borderColor: "#247ADF",
          isTemporary: false,
          leftSection: "REVIEW_AI"
        }
      },
      modelsReducer: {
        todos: {
          BUDGET_SUBGROUP: {
            x: 9,
            y: 7,
            id: "BUDGET_SUBGROUP",
            text: "Select Subgroup",
            color: "#00B5D0",
            index: 6,
            author: "Aible Admin",
            parent: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            actionId: 0,
            hideSave: true,
            afterText: "Subgroup focus: Admission Type Id",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "",
              total: 20000,
              models: [],
              ignored: {},
              success: { count: 36448, label: "No", value: "No" },
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "1",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
              fieldTypes: {},
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Not Discharge",
              falseAction: "Release",
              isBlueprint: true,
              splitColumn: "Admission Type Id",
              advancedCost: -4000,
              customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Readmission",
              processLimit: 0,
              showBusiness: true,
              trueNegative: 0,
              truePositive: 36448,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 0,
              falsePositive: 19684,
              ignoredModels: {},
              conversionCost: -4000,
              conversionGain: 5000,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 9000,
              conversionSaved: 0,
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -5000,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Patients",
              advancedCostLabel: "Holding Cost",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Loss",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Discharged",
              truePositiveLabel: "Correctly Held",
              falseNegativeLabel: "Incorrectly Discharged",
              falsePositiveLabel: "Incorrectly Held",
              underPredictAction: "Underestimate Loss",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Holding Revenue",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Patients"
            },
            borderColor: "#00B5D0",
            leftSection: "SUBGROUP",
            updatedDate: 1635891682555
          },
          EVAL_MODEL_DRIVERS: {
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 1,
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: { x: 0, y: 1 },
              oChildDelta: { x: 0, y: 1 },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI"
          }
        },
        hexMap: {
          "7_8": {
            x: 7,
            y: 8,
            id: "DEPLOY",
            icon: "Rocket",
            text: "I want to deploy the current AI",
            color: "#EC6417",
            index: 3,
            selected: {
              0: {
                id: "DEPLOY_REVIEW",
                text: "Review & Approve Deployment Settings",
                borderColor: "#EC6417",
                leftSection: "DEPLOY_SETTINGS"
              },
              1: {
                id: "DEPLOY_INTEGRATION",
                text: "Integrate into your business systems",
                afterText: "Integration has been added",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "INTEGRATE"
              },
              2: {
                id: "DEPLOY_MONITOR",
                text: "Add Monitoring Settings",
                afterText: "Monitoring settings have been updated",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "MONITOR"
              }
            },
            background: "#EC6417",
            childDelta: { x: -1, y: 1 },
            oChildDelta: { x: -1, y: 0 },
            sectionType: "DEPLOY"
          },
          "8_7": {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          "8_9": {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: { x: 0, y: 1 },
            oChildDelta: { x: 0, y: 1 },
            sectionType: "DEPLOY"
          },
          "9_7": {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                hideSave: true,
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: { x: 1, y: 0 },
            oChildDelta: { x: 1, y: -1 },
            sectionType: "FAIRNESS"
          },
          "9_8": {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                hideSave: true,
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: { x: 1, y: 1 },
            oChildDelta: { x: 1, y: 1 },
            sectionType: "BUDGET"
          }
        },
        isTodo: true,
        centerHex: {
          x: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
          y: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" }
        },
        isLoading: false,
        beforeSetup: {},
        replayIndex: 4,
        savedHexMap: {
          "7_7": {
            x: 7,
            y: 8,
            icon: "Join",
            text: "Dataset Name",
            color: "#059669",
            isBase: true,
            leftSection: "DATASET"
          },
          "8_5": {
            x: 8,
            y: 6,
            id: "OPTIMIZE_BLUEPRINT",
            icon: "Blueprint",
            text: "Add Business Use Case Language",
            color: "#7E69D7",
            index: 3,
            author: "Aible Admin",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 0,
            afterText: " ",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "",
              total: 20000,
              models: [],
              ignored: {},
              success: { count: 36448, label: "No", value: "No" },
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "1",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
              fieldTypes: {},
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Not Discharge",
              falseAction: "Release",
              isBlueprint: true,
              advancedCost: -4000,
              customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Readmission",
              processLimit: 0,
              showBusiness: true,
              trueNegative: 0,
              truePositive: 36448,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 0,
              falsePositive: 19684,
              ignoredModels: {},
              conversionCost: -4000,
              conversionGain: 5000,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 9000,
              conversionSaved: 0,
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -5000,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Patients",
              advancedCostLabel: "Holding Cost",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Loss",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Discharged",
              truePositiveLabel: "Correctly Held",
              falseNegativeLabel: "Incorrectly Discharged",
              falsePositiveLabel: "Incorrectly Held",
              underPredictAction: "Underestimate Loss",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Holding Revenue",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Patients"
            },
            isTemporary: true,
            leftSection: "BLUEPRINT",
            updatedDate: 1635891659631
          },
          "8_6": {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            index: 2,
            author: "Aible Admin",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "",
              total: 20000,
              models: [],
              ignored: {},
              success: { count: 36448, label: "No", value: "No" },
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "1",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
              fieldTypes: {},
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Action",
              falseAction: "Ignore",
              isBlueprint: true,
              advancedCost: -4000,
              customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Success",
              processLimit: 0,
              showBusiness: true,
              trueNegative: 0,
              truePositive: 36448,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 0,
              falsePositive: 19684,
              ignoredModels: {},
              conversionCost: -4000,
              conversionGain: 5000,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 9000,
              conversionSaved: 0,
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -5000,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Transactions",
              advancedCostLabel: "Holding Cost",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Loss",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Discharged",
              truePositiveLabel: "Correctly Held",
              falseNegativeLabel: "Incorrectly Discharged",
              falsePositiveLabel: "Incorrectly Held",
              underPredictAction: "Underestimate Loss",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Holding Revenue",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Records"
            },
            isTemporary: true,
            leftSection: "EXPECTED",
            updatedDate: 1635891630993
          },
          "8_8": {
            x: 8,
            y: 8,
            icon: "Blueprint",
            text: "Marketing Use Case",
            color: "#7e69d7",
            isBase: true,
            canStart: false,
            selected: {},
            leftSection: "HOME"
          },
          "10_9": {
            x: 9,
            y: 7,
            id: "BUDGET_SUBGROUP",
            text: "Select Subgroup",
            color: "#00B5D0",
            index: 6,
            author: "Aible Admin",
            parent: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            actionId: 0,
            hideSave: true,
            afterText: "Subgroup focus: Admission Type Id",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "",
              total: 20000,
              models: [],
              ignored: {},
              success: { count: 36448, label: "No", value: "No" },
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "1",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -4000, conversionGain: 5000, conversionSaved: 0, conversionMissed: -5000 },
              fieldTypes: {},
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Not Discharge",
              falseAction: "Release",
              isBlueprint: true,
              splitColumn: "Admission Type Id",
              advancedCost: -4000,
              customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Readmission",
              processLimit: 0,
              showBusiness: true,
              trueNegative: 0,
              truePositive: 36448,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 0,
              falsePositive: 19684,
              ignoredModels: {},
              conversionCost: -4000,
              conversionGain: 5000,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 9000,
              conversionSaved: 0,
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -5000,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Patients",
              advancedCostLabel: "Holding Cost",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Loss",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Discharged",
              truePositiveLabel: "Correctly Held",
              falseNegativeLabel: "Incorrectly Discharged",
              falsePositiveLabel: "Incorrectly Held",
              underPredictAction: "Underestimate Loss",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Holding Revenue",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Patients"
            },
            borderColor: "#00B5D0",
            leftSection: "SUBGROUP",
            updatedDate: 1635891682555
          },
          "8_10": {
            x: 8,
            y: 10,
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#7E69D7",
            index: 5,
            author: "Aible Admin",
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: { x: 0, y: 1 },
              oChildDelta: { x: 0, y: 1 },
              sectionType: "DEPLOY"
            },
            actionId: 999,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI",
            updatedDate: 1635891681188
          }
        },
        actionHexMap: {},
        savedActions: [
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              leftSection: "EXPECTED"
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            node: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "EXPECTED"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "EXPECTED"
          },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              leftSection: "BLUEPRINT"
            },
            hex: { x: 8, y: 6 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              },
              y: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              }
            },
            node: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "BLUEPRINT"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "BLUEPRINT"
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            hex: { x: 9, y: 8 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "BUDGET_SUBGROUP",
              text: "Select Subgroup",
              color: "#00B5D0",
              parent: {
                x: 9,
                y: 8,
                id: "BUDGET",
                icon: "Resource",
                text: "I want Aible to find the optimal resource allocation across subgroups",
                color: "#00B5D0",
                index: 2,
                selected: {
                  0: {
                    id: "BUDGET_SUBGROUP",
                    text: "Select Subgroup",
                    hideSave: true,
                    afterText: "A subgroup has been selected",
                    hasUpdate: true,
                    borderColor: "#00B5D0",
                    leftSection: "SUBGROUP"
                  }
                },
                background: "#00B5D0",
                childDelta: { x: 1, y: 1 },
                oChildDelta: { x: 1, y: 1 },
                sectionType: "BUDGET"
              },
              actionId: 0,
              hideSave: true,
              afterText: "A subgroup has been selected",
              hasUpdate: true,
              borderColor: "#00B5D0",
              leftSection: "SUBGROUP"
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            hex: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            type: "UPDATE_SELECTED_HEX",
            isInstant: true,
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "BUDGET_SUBGROUP",
              text: "Select Subgroup",
              color: "#00B5D0",
              parent: {
                x: 9,
                y: 8,
                id: "BUDGET",
                icon: "Resource",
                text: "I want Aible to find the optimal resource allocation across subgroups",
                color: "#00B5D0",
                index: 2,
                selected: {
                  0: {
                    id: "BUDGET_SUBGROUP",
                    text: "Select Subgroup",
                    hideSave: true,
                    afterText: "A subgroup has been selected",
                    hasUpdate: true,
                    borderColor: "#00B5D0",
                    leftSection: "SUBGROUP"
                  }
                },
                background: "#00B5D0",
                childDelta: { x: 1, y: 1 },
                oChildDelta: { x: 1, y: 1 },
                sectionType: "BUDGET"
              },
              actionId: 0,
              hideSave: true,
              afterText: "A subgroup has been selected",
              hasUpdate: true,
              borderColor: "#00B5D0",
              leftSection: "SUBGROUP"
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            hex: {
              x: 9,
              y: 8,
              id: "BUDGET",
              icon: "Resource",
              text: "I want Aible to find the optimal resource allocation across subgroups",
              color: "#00B5D0",
              index: 2,
              selected: {
                0: {
                  id: "BUDGET_SUBGROUP",
                  text: "Select Subgroup",
                  hideSave: true,
                  afterText: "A subgroup has been selected",
                  hasUpdate: true,
                  borderColor: "#00B5D0",
                  leftSection: "SUBGROUP"
                }
              },
              background: "#00B5D0",
              childDelta: { x: 1, y: 1 },
              oChildDelta: { x: 1, y: 1 },
              sectionType: "BUDGET"
            },
            type: "UPDATE_SELECTED_HEX",
            isInstant: true,
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "BUDGET_SUBGROUP",
              text: "Select Subgroup",
              color: "#00B5D0",
              parent: {
                x: 9,
                y: 8,
                id: "BUDGET",
                icon: "Resource",
                text: "I want Aible to find the optimal resource allocation across subgroups",
                color: "#00B5D0",
                index: 2,
                selected: {
                  0: {
                    id: "BUDGET_SUBGROUP",
                    text: "Select Subgroup",
                    hideSave: true,
                    afterText: "A subgroup has been selected",
                    hasUpdate: true,
                    borderColor: "#00B5D0",
                    leftSection: "SUBGROUP"
                  }
                },
                background: "#00B5D0",
                childDelta: { x: 1, y: 1 },
                oChildDelta: { x: 1, y: 1 },
                sectionType: "BUDGET"
              },
              actionId: 0,
              hideSave: true,
              afterText: "A subgroup has been selected",
              hasUpdate: true,
              borderColor: "#00B5D0",
              leftSection: "SUBGROUP"
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: { x: 9, y: 7 },
            node: {
              x: 9,
              y: 7,
              id: "BUDGET_SUBGROUP",
              text: "Select Subgroup",
              color: "#00B5D0",
              parent: {
                x: 9,
                y: 8,
                id: "BUDGET",
                icon: "Resource",
                text: "I want Aible to find the optimal resource allocation across subgroups",
                color: "#00B5D0",
                index: 2,
                selected: {
                  0: {
                    id: "BUDGET_SUBGROUP",
                    text: "Select Subgroup",
                    hideSave: true,
                    afterText: "A subgroup has been selected",
                    hasUpdate: true,
                    borderColor: "#00B5D0",
                    leftSection: "SUBGROUP"
                  }
                },
                background: "#00B5D0",
                childDelta: { x: 1, y: 1 },
                oChildDelta: { x: 1, y: 1 },
                sectionType: "BUDGET"
              },
              actionId: 0,
              hideSave: true,
              afterText: "A subgroup has been selected",
              hasUpdate: true,
              borderColor: "#00B5D0",
              leftSection: "SUBGROUP"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "SUBGROUP"
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "BUDGET_SUBGROUP",
              text: "Select Subgroup",
              color: "#00B5D0",
              index: 6,
              author: "Aible Admin",
              parent: {
                x: 9,
                y: 8,
                id: "BUDGET",
                icon: "Resource",
                text: "I want Aible to find the optimal resource allocation across subgroups",
                color: "#00B5D0",
                index: 2,
                selected: {
                  0: {
                    id: "BUDGET_SUBGROUP",
                    text: "Select Subgroup",
                    hideSave: true,
                    afterText: "A subgroup has been selected",
                    hasUpdate: true,
                    borderColor: "#00B5D0",
                    leftSection: "SUBGROUP"
                  }
                },
                background: "#00B5D0",
                childDelta: { x: 1, y: 1 },
                oChildDelta: { x: 1, y: 1 },
                sectionType: "BUDGET"
              },
              actionId: 0,
              hideSave: true,
              afterText: "Subgroup focus: Admission Type Id",
              hasUpdate: true,
              setupStep: {},
              afterSetup: {
                goal: "Maximize",
                mode: 2,
                label: "",
                total: 20000,
                models: [],
                ignored: {},
                success: { count: 36448, label: "No", value: "No" },
                useCase: "Sales Prediction",
                aimToHit: 800,
                endState: [],
                targeted: 2000,
                unitType: "$",
                auditable: false,
                datasetId: "1",
                hideCosts: false,
                threshold: [0, 0],
                contAction: "Sell",
                errorCosts: {
                  conversionCost: -4000,
                  conversionGain: 5000,
                  conversionSaved: 0,
                  conversionMissed: -5000
                },
                fieldTypes: {},
                isQuickRun: false,
                timePeriod: "Month",
                trueAction: "Not Discharge",
                falseAction: "Release",
                isBlueprint: true,
                splitColumn: "Admission Type Id",
                advancedCost: -4000,
                customValues: { Cost_Of_Care: 4000, Hospital_Revenue: 9000, Readmission_Penalty: 1000 },
                fieldReplace: {},
                modelOptions: [],
                outcomeLabel: "Readmission",
                processLimit: 0,
                showBusiness: true,
                trueNegative: 0,
                truePositive: 36448,
                advancedInput: {},
                biasReduction: "Impact",
                falseNegative: 0,
                falsePositive: 19684,
                ignoredModels: {},
                conversionCost: -4000,
                conversionGain: 5000,
                conversionRate: 5,
                customMappings: {},
                netImpactLabel: "Impact",
                advancedRevenue: 9000,
                conversionSaved: 0,
                numberPredicted: "Price",
                realTimeResults: false,
                aiTrainingBudget: 200,
                conversionMissed: -5000,
                hasLinkedProject: false,
                isForceOptimized: false,
                transactionLabel: "Patients",
                advancedCostLabel: "Holding Cost",
                businessObjective: "Profit",
                fairnessObjective: "None",
                overPredictAction: "Overestimate Loss",
                overestimateLabel: "Overestimate",
                trueNegativeLabel: "Correctly Discharged",
                truePositiveLabel: "Correctly Held",
                falseNegativeLabel: "Incorrectly Discharged",
                falsePositiveLabel: "Incorrectly Held",
                underPredictAction: "Underestimate Loss",
                underestimateLabel: "Underestimate",
                academicResultsStep: 0,
                humanUnderstandable: false,
                advancedRevenueLabel: "Holding Revenue",
                baselineCustomValues: {},
                maximumConversionRate: 5,
                fairnessToleranceBound: 1,
                notPursuedTransactionLabel: "Patients"
              },
              borderColor: "#00B5D0",
              leftSection: "SUBGROUP",
              updatedDate: 1635891682555
            },
            hex: { x: 10, y: 9 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
            hex: { x: 8, y: 8 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
              y: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" }
            },
            node: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "OUTCOME"
          },
          {
            hex: {
              x: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
              y: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" }
            },
            node: { x: 8, y: 8, id: "OUTCOME", text: "Dataset Settings", color: "#059669", leftSection: "OUTCOME" },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "OUTCOME"
          },
          { type: "HANDLE_BACK", isVisible: false }
        ],
        todoMaximize: { BUDGET_SUBGROUP: true }
      }
    },
    sensitive: {},
    customFields: {
      Cost_Of_Care: { id: "Cost_Of_Care", desc: "Costs associated with a full day of care" },
      Hospital_Revenue: { id: "Hospital_Revenue", desc: "Revenue for a full day of care" },
      Readmission_Penalty: {
        id: "Readmission_Penalty",
        desc: "Additional cost to hospital for a readmission (in addition to the cost of care)"
      }
    },
    advancedInputs: {
      advancedCost: "-Cost_of_care",
      trueNegative: "0",
      truePositive: "Hospital_Revenue-Cost_of_care",
      falseNegative: "-Cost_of_care-Readmission_Penalty",
      falsePositive: "-Cost_of_care",
      advancedRevenue: "Hospital_Revenue"
    }
  }
};

const SUBSCRIPTION_SALES = {
  ...DEFAULT_USE_CASE_SETTINGS,
  outcome_behavior: "MAXIMIZE",
  id: "SUBSCRIPTION_SALES",
  name: "Subscription Sales",
  suggested_fields: [],
  wizard: {
    setup: {
      goal: "Maximize",
      mode: 2,
      label: "Subscription Sales",
      total: 20000,
      models: [],
      ignored: {},
      useCase: "Sales Prediction",
      aimToHit: 800,
      endState: [],
      targeted: 2000,
      unitType: "$",
      auditable: false,
      datasetId: "7625",
      hideCosts: false,
      threshold: [0, 0],
      contAction: "Sell",
      errorCosts: { conversionCost: -294, conversionGain: 1488, conversionSaved: 0, conversionMissed: 0 },
      fieldTypes: {},
      isForecast: false,
      isQuickRun: false,
      timePeriod: "Year",
      trueAction: "Pursue",
      blueprintId: 306,
      falseAction: "Deprioritize",
      isBlueprint: true,
      splitColumn: "Lead Source",
      advancedCost: 294,
      customValues: {
        Margin: 0.33,
        Avg_Deal_Size: 54000,
        Cost_Per_Lead: 130,
        Avg_Sales_Cost: 164,
        Opportunity_Rate: 0.1
      },
      fieldReplace: {},
      ignoredValue: {},
      modelOptions: [],
      outcomeLabel: "Successful Sale",
      processLimit: 0,
      pursuedRatio: "20",
      showBusiness: true,
      trueNegative: 13950,
      truePositive: 2000,
      advancedInput: {},
      biasReduction: "Impact",
      falseNegative: 1550,
      falsePositive: 8000,
      ignoredModels: {},
      conversionCost: -294,
      conversionGain: 1488,
      conversionRate: 5,
      customMappings: {},
      netImpactLabel: "Net Profit",
      advancedRevenue: 5400,
      conversionSaved: 0,
      notPursuedRatio: "10",
      numberPredicted: "Price",
      realTimeResults: false,
      aiTrainingBudget: 200,
      conversionMissed: 0,
      hasLinkedProject: false,
      isForceOptimized: false,
      transactionLabel: "Opportunities",
      advancedCostLabel: "Sales Resourcing",
      businessObjective: "Profit",
      fairnessObjective: "None",
      overPredictAction: "Overestimate Cost",
      overestimateLabel: "Overestimate",
      trueNegativeLabel: "Correctly deprioritized",
      truePositiveLabel: "Prioritized Sale",
      falseNegativeLabel: "Missed opportunity",
      falsePositiveLabel: "Pursued but not won",
      underPredictAction: "Underestimate Cost",
      underestimateLabel: "Underestimate",
      academicResultsStep: 0,
      businessConstraints: [{ min: 1.5, mode: "percent", type: "revenue" }],
      humanUnderstandable: false,
      advancedRevenueLabel: "Revenue",
      baselineCustomValues: {},
      enableFairnessMetrics: false,
      maximumConversionRate: 5,
      fairnessToleranceBound: 1,
      notPursuedTransactionLabel: "Sales Leads"
    },
    dataset: {
      id: "SUBSCRIPTION_SALES",
      name: "Subscription Sales.csv",
      label: "Subscription Sales.csv",
      errors: [],
      fields: {
        Plan: { type: "categorical", label: "Plan" },
        Term: { type: "categorical", label: "Term" },
        Gender: { type: "categorical", label: "Gender" },
        Region: { type: "categorical", label: "Region" },
        "Comm Id": { type: "categorical", label: "Comm Id" },
        "Lead Id": { type: "categorical", label: "Lead Id" },
        Category: { type: "categorical", label: "Category" },
        "Phone No": { type: "categorical", label: "Phone No" },
        Ethnicity: { type: "categorical", label: "Ethnicity" },
        "SMS Count": { type: "categorical", label: "SMS Count" },
        "Call Count": { type: "categorical", label: "Call Count" },
        "Product Id": { type: "categorical", label: "Product Id" },
        "Time Stamp": { type: "date", label: "Time Stamp" },
        "Annual Cost": { type: "categorical", label: "Annual Cost" },
        "Campaign Id": { type: "categorical", label: "Campaign Id" },
        "Day of Week": { type: "categorical", label: "Day of Week" },
        "Email Count": { type: "categorical", label: "Email Count" },
        "Launch Date": { type: "date", label: "Launch Date" },
        "Lead Source": { type: "categorical", label: "Lead Source" },
        "Time Of Day": { type: "categorical", label: "Time Of Day" },
        "Usage Limit": { type: "categorical", label: "Usage Limit" },
        "Age Category": { type: "categorical", label: "Age Category" },
        "Credit Score": { type: "categorical", label: "Credit Score" },
        "Sub Category": { type: "categorical", label: "Sub Category" },
        "Campaign Name": { type: "categorical", label: "Campaign Name" },
        "No of Devices": { type: "categorical", label: "No of Devices" },
        "Expected Usage": { type: "categorical", label: "Expected Usage" },
        "Household Size": { type: "categorical", label: "Household Size" },
        "Marital Status": { type: "categorical", label: "Marital Status" },
        "No Of Children": { type: "categorical", label: "No Of Children" },
        "Call For Action": { type: "categorical", label: "Call For Action" },
        "Successful Sale": { type: "categorical", label: "Successful Sale" },
        "Campaign Drivers": { type: "categorical", label: "Campaign Drivers" },
        "No Of Dependents": { type: "categorical", label: "No Of Dependents" },
        "Focused Geography": { type: "categorical", label: "Focused Geography" },
        "Highest Education": { type: "categorical", label: "Highest Education" },
        "Payment Frequency": { type: "categorical", label: "Payment Frequency" },
        "Tenure Of Campaign": { type: "categorical", label: "Tenure Of Campaign" },
        "Annual Income Bucket": { type: "categorical", label: "Annual Income Bucket" },
        "Secondary Lead Source": { type: "categorical", label: "Secondary Lead Source" }
      },
      labels: [
        "Lead Id",
        "Age Category",
        "Phone No",
        "Annual Income Bucket",
        "Credit Score",
        "No Of Dependents",
        "Highest Education",
        "Ethnicity",
        "No Of Children",
        "Household Size",
        "Gender",
        "Marital Status",
        "Time Of Day",
        "Campaign Id",
        "Day of Week",
        "Comm Id",
        "Time Stamp",
        "Plan",
        "Category",
        "Term",
        "No of Devices",
        "Annual Cost",
        "Payment Frequency",
        "Usage Limit",
        "Sub Category",
        "Campaign Drivers",
        "Launch Date",
        "Call For Action",
        "Focused Geography",
        "Tenure Of Campaign",
        "Expected Usage",
        "Product Id",
        "SMS Count",
        "Email Count",
        "Call Count",
        "Secondary Lead Source",
        "Lead Source",
        "Region",
        "Campaign Name",
        "Successful Sale"
      ],
      source: {
        url: "s3://aible-769303959801-1001/uploads/prod/uploads/tenant_2/d97273/raw",
        type: {
          id: 1,
          status: "ACTIVE",
          pattern: "s3:\\/\\/([^/]+)(?=\\/)\\/?(.*)",
          service_name: "S3",
          provider_name: "Amazon"
        },
        content: { type: "RAW_DATA" }
      },
      status: ["indexed"],
      target: "Successful Sale",
      created: "2021-09-27T15:21:45",
      deleted: false,
      outcome: "Successful Sale",
      isHidden: true,
      rowCount: 100000,
      stack_id: null,
      warnings: [
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Lead Id",
            message: "Column 'Lead Id' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Phone No",
            message: "Column 'Phone No' has too few recurring values.  It would be discarded."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Category",
            message: "Column 'Category' has only one unique value.  It would be discarded."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "NoSignalWarning",
          type: "warning",
          scope: "",
          message: "No Signal; see message for further details.",
          metadata: {
            column: "Focused Geography",
            message: "Column 'Focused Geography' has only one unique value.  It would be discarded."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column No Of Dependents has 961 missing values out of 100000 total values, comprising 0.96 % of the data in this column.",
          metadata: {
            column: "No Of Dependents",
            percentage: 0.961,
            num_missing: 961,
            num_observed: 99039,
            unique_message:
              " Column No Of Dependents has 961 missing values out of 100000 total values, comprising 0.96 % of the data in this column."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Highest Education has 1030 missing values out of 100000 total values, comprising 1.03 % of the data in this column.",
          metadata: {
            column: "Highest Education",
            percentage: 1.03,
            num_missing: 1030,
            num_observed: 98970,
            unique_message:
              " Column Highest Education has 1030 missing values out of 100000 total values, comprising 1.03 % of the data in this column."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column No Of Children has 1019 missing values out of 100000 total values, comprising 1.02 % of the data in this column.",
          metadata: {
            column: "No Of Children",
            percentage: 1.019,
            num_missing: 1019,
            num_observed: 98981,
            unique_message:
              " Column No Of Children has 1019 missing values out of 100000 total values, comprising 1.02 % of the data in this column."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Household Size has 1006 missing values out of 100000 total values, comprising 1.01 % of the data in this column.",
          metadata: {
            column: "Household Size",
            percentage: 1.006,
            num_missing: 1006,
            num_observed: 98994,
            unique_message:
              " Column Household Size has 1006 missing values out of 100000 total values, comprising 1.01 % of the data in this column."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Lead Id",
            message:
              "Lead Id has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-09-27T15:22:31"
        },
        {
          code: "HighCardinalityKeepWarning",
          type: "warning",
          scope: "columns to reduce",
          message: "Too many values to model; will keep most informative values",
          metadata: {
            col: "Phone No",
            message:
              "Phone No has too many values to model.  Its most informative values would be flagged and included in the modeling step."
          },
          created_date: "2021-09-27T15:22:31"
        }
      ],
      accountId: 1001,
      file_size: 29,
      folder_id: 358,
      recipe_id: null,
      sourceUrl: "s3://aible-769303959801-1001/uploads/prod/uploads/tenant_2/d97273/raw",
      tenant_id: 2,
      account_id: 1001,
      created_by: { id: 750, fullname: "Alex Burke" },
      hasRulefit: false,
      like_count: 0,
      annotations: [
        {
          type: "info",
          scope: "*",
          message:
            "Started Lambda Stack at arn:aws:lambda::us-east-1:validate-headers-22abc362cd3b4e128caf50c370017e78",
          created_date: "2021-09-27T15:21:52"
        },
        {
          type: "info",
          scope: "*",
          message: "Started Lambda Stack at arn:aws:lambda::us-east-1:data-analysis-b8fb5784f7e74576a6d698287655bd79",
          created_date: "2021-09-27T16:05:07"
        }
      ],
      permissions: {
        can_edit: true,
        can_view: true,
        can_delete: true,
        can_give_feedback: true,
        can_manage_permissions: true
      },
      status_name: "DONE",
      created_date: "2021-09-27T15:21:45",
      descriptions: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      target_index: 39,
      updated_date: "2021-09-27T16:06:25",
      comment_count: 0,
      dislike_count: 0,
      dataset_status: "DONE",
      number_of_rows: 100000,
      overall_status: ["indexed"],
      transformations: { row_filters: [] },
      schema_monitor_id: null,
      categorical_counts: [
        [
          "Lead Id",
          [
            ["ID 00100000", 1],
            ["ID 00033350", 1],
            ["ID 00033328", 1],
            ["ID 00033329", 1],
            ["ID 00033330", 1],
            ["ID 00033331", 1],
            ["ID 00033332", 1],
            ["ID 00033333", 1],
            ["ID 00033334", 1],
            ["ID 00033335", 1],
            ["ID 00033336", 1],
            ["ID 00033337", 1],
            ["ID 00033338", 1],
            ["ID 00033339", 1],
            ["ID 00033340", 1],
            ["ID 00033341", 1],
            ["ID 00033342", 1],
            ["ID 00033343", 1],
            ["ID 00033344", 1],
            ["ID 00033345", 1],
            ["ID 00033346", 1],
            ["ID 00033347", 1],
            ["ID 00033348", 1],
            ["ID 00033327", 1],
            ["ID 00033326", 1],
            ["ID 00033325", 1],
            ["ID 00033313", 1],
            ["ID 00033304", 1],
            ["ID 00033305", 1],
            ["ID 00033306", 1],
            ["ID 00033307", 1],
            ["ID 00033308", 1],
            ["ID 00033309", 1],
            ["ID 00033310", 1],
            ["ID 00033311", 1],
            ["ID 00033312", 1],
            ["ID 00033314", 1],
            ["ID 00033324", 1],
            ["ID 00033315", 1],
            ["ID 00033316", 1],
            ["ID 00033317", 1],
            ["ID 00033318", 1],
            ["ID 00033319", 1],
            ["ID 00033320", 1],
            ["ID 00033321", 1],
            ["ID 00033322", 1],
            ["ID 00033323", 1],
            ["ID 00033349", 1],
            ["ID 00033351", 1],
            ["ID 00033302", 1],
            ["{Other}", 99950]
          ]
        ],
        [
          "Age Category",
          [
            ["A-Young", 33213],
            ["B-Middle", 32729],
            ["C-Senior", 34058]
          ]
        ],
        [
          "Phone No",
          [
            ["100-009-9999", 1],
            ["100-003-3349", 1],
            ["100-003-3327", 1],
            ["100-003-3328", 1],
            ["100-003-3329", 1],
            ["100-003-3330", 1],
            ["100-003-3331", 1],
            ["100-003-3332", 1],
            ["100-003-3333", 1],
            ["100-003-3334", 1],
            ["100-003-3335", 1],
            ["100-003-3336", 1],
            ["100-003-3337", 1],
            ["100-003-3338", 1],
            ["100-003-3339", 1],
            ["100-003-3340", 1],
            ["100-003-3341", 1],
            ["100-003-3342", 1],
            ["100-003-3343", 1],
            ["100-003-3344", 1],
            ["100-003-3345", 1],
            ["100-003-3346", 1],
            ["100-003-3347", 1],
            ["100-003-3326", 1],
            ["100-003-3325", 1],
            ["100-003-3324", 1],
            ["100-003-3312", 1],
            ["100-003-3303", 1],
            ["100-003-3304", 1],
            ["100-003-3305", 1],
            ["100-003-3306", 1],
            ["100-003-3307", 1],
            ["100-003-3308", 1],
            ["100-003-3309", 1],
            ["100-003-3310", 1],
            ["100-003-3311", 1],
            ["100-003-3313", 1],
            ["100-003-3323", 1],
            ["100-003-3314", 1],
            ["100-003-3315", 1],
            ["100-003-3316", 1],
            ["100-003-3317", 1],
            ["100-003-3318", 1],
            ["100-003-3319", 1],
            ["100-003-3320", 1],
            ["100-003-3321", 1],
            ["100-003-3322", 1],
            ["100-003-3348", 1],
            ["100-003-3350", 1],
            ["100-003-3301", 1],
            ["{Other}", 99950]
          ]
        ],
        [
          "Annual Income Bucket",
          [
            ["<=60k", 32785],
            [">120k", 34117],
            [">60k-120k", 33098]
          ]
        ],
        [
          "Credit Score",
          [
            ["<=350", 47062],
            [">350-700", 23915],
            [">700", 29023]
          ]
        ],
        [
          "No Of Dependents",
          [
            ["0.0", 54152],
            ["1.0", 27154],
            ["2.0", 14072],
            ["3.0", 3661],
            ["{Missing}", 961]
          ]
        ],
        [
          "Highest Education",
          [
            ["Attended Vocational", 25242],
            ["College", 23729],
            ["Graduate School", 28691],
            ["High School", 21308],
            ["{Missing}", 1030]
          ]
        ],
        [
          "Ethnicity",
          [
            ["African American", 25263],
            ["Asian", 25065],
            ["Hispanic", 24898],
            ["Whites", 24774]
          ]
        ],
        [
          "No Of Children",
          [
            ["0.0", 37671],
            ["1.0", 11834],
            ["2.0", 27785],
            ["3.0", 21691],
            ["{Missing}", 1019]
          ]
        ],
        [
          "Household Size",
          [
            ["1.0", 54237],
            ["2.0", 27027],
            ["3.0", 14062],
            ["4.0", 3668],
            ["{Missing}", 1006]
          ]
        ],
        [
          "Gender",
          [
            ["F", 46249],
            ["M", 53751]
          ]
        ],
        [
          "Marital Status",
          [
            ["D", 25085],
            ["M", 25194],
            ["S", 24936],
            ["W", 24785]
          ]
        ],
        [
          "Time Of Day",
          [
            ["Afternoon", 32475],
            ["Evening", 33079],
            ["Morning", 34446]
          ]
        ],
        [
          "Campaign Id",
          [
            ["2", 19995],
            ["3", 20218],
            ["4", 19721],
            ["5", 19910],
            ["6", 20156]
          ]
        ],
        [
          "Day of Week",
          [
            ["1-Mon", 20358],
            ["2-Tues", 11702],
            ["3-Wed", 11975],
            ["4-Thurs", 9233],
            ["5-Fri", 13845],
            ["6-Sat", 15037],
            ["7-Sun", 17850]
          ]
        ],
        [
          "Comm Id",
          [
            ["4", 33260],
            ["5", 33217],
            ["6", 33523]
          ]
        ],
        [
          "Time Stamp",
          [
            ["2014-03-21T00:00:00.000000Z", 1],
            ["2014-12-31T00:00:00.000000Z", 1]
          ]
        ],
        [
          "Plan",
          [
            ["Global Unlimited", 19910],
            ["Group Basics", 19995],
            ["Group Unlimited", 19721],
            ["Solo Basics", 20218],
            ["Solo Unlimited", 20156]
          ]
        ],
        ["Category", [["Acquisition", 100000]]],
        [
          "Term",
          [
            ["10", 19995],
            ["15", 20218],
            ["16", 20156],
            ["24", 19721],
            ["30", 19910]
          ]
        ],
        [
          "No of Devices",
          [
            ["2", 39939],
            ["4", 39905],
            ["5", 20156]
          ]
        ],
        [
          "Annual Cost",
          [
            ["700", 19910],
            ["900", 19721],
            ["1000", 19995],
            ["1500", 20218],
            ["2000", 20156]
          ]
        ],
        [
          "Payment Frequency",
          [
            ["Monthly", 40213],
            ["Quarterly", 39631],
            ["Yearly", 20156]
          ]
        ],
        [
          "Usage Limit",
          [
            ["<200000", 79782],
            ["<400000", 20218]
          ]
        ],
        [
          "Sub Category",
          [
            ["Branding", 20218],
            ["Penetration", 59787],
            ["Seasonal", 19995]
          ]
        ],
        [
          "Campaign Drivers",
          [
            ["Additional Coverage", 20218],
            ["Extra benefits", 79782]
          ]
        ],
        [
          "Launch Date",
          [
            ["2014-03-21T00:00:00.000000Z", 1],
            ["2014-12-05T00:00:00.000000Z", 1]
          ]
        ],
        [
          "Call For Action",
          [
            ["0", 39631],
            ["1", 60369]
          ]
        ],
        ["Focused Geography", [["Nation Wide", 100000]]],
        [
          "Tenure Of Campaign",
          [
            ["1", 59934],
            ["2", 40066]
          ]
        ],
        [
          "Expected Usage",
          [
            ["100000", 39905],
            ["150000", 20156],
            ["200000", 39939]
          ]
        ],
        [
          "Product Id",
          [
            ["1", 19995],
            ["2", 20218],
            ["4", 19910],
            ["5", 19721],
            ["6", 20156]
          ]
        ],
        [
          "SMS Count",
          [
            ["0", 11000],
            ["1", 25046],
            ["2", 27763],
            ["3", 21280],
            ["4", 10934],
            ["5", 3421],
            ["6", 556]
          ]
        ],
        [
          "Email Count",
          [
            ["0", 25813],
            ["1", 34725],
            ["2", 24389],
            ["3", 11123],
            ["4", 3335],
            ["5", 569],
            ["6", 46]
          ]
        ],
        [
          "Call Count",
          [
            ["0", 25776],
            ["1", 29687],
            ["2", 19923],
            ["3", 13381],
            ["4", 7967],
            ["5", 2799],
            ["6", 467]
          ]
        ],
        [
          "Secondary Lead Source",
          [
            ["Digital Marketing", 31603],
            ["Direct", 26363],
            ["Events", 42034]
          ]
        ],
        [
          "Lead Source",
          [
            ["Digital Marketing", 31865],
            ["Direct", 27115],
            ["Events", 41020]
          ]
        ],
        [
          "Region",
          [
            ["EMEA", 36252],
            ["LATAM", 22999],
            ["US", 40749]
          ]
        ],
        [
          "Campaign Name",
          [
            ["Campaign A", 19995],
            ["Campaign B", 19910],
            ["Campaign C", 19721],
            ["Campaign D", 20218],
            ["Campaign E", 20156]
          ]
        ],
        [
          "Successful Sale",
          [
            ["No", 90061],
            ["Yes", 9939]
          ]
        ]
      ],
      rulefit_definitions: []
    },
    nextObj: {
      todos: {
        OPTIMIZE_STRATEGY: {
          x: 8,
          y: 8,
          id: "OPTIMIZE_STRATEGY",
          text: "Add Business Strategy Recommendations",
          color: "#7E69D7",
          index: 1,
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          actionId: 3,
          afterText: "Strategy Updated",
          hasUpdate: true,
          isTemporary: false,
          leftSection: "STRATEGY"
        },
        EVAL_MODEL_DRIVERS: {
          x: 9,
          y: 8,
          id: "EVAL_MODEL_DRIVERS",
          icon: "Gears",
          text: "Evaluate Model Drivers",
          color: "#247ADF",
          index: 0,
          parent: {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: { x: 0, y: 1 },
            oChildDelta: { x: 0, y: 1 },
            sectionType: "DEPLOY"
          },
          actionId: 1,
          hideSave: true,
          hasUpdate: true,
          borderColor: "#247ADF",
          isTemporary: false,
          leftSection: "REVIEW_AI"
        }
      },
      modelsReducer: {
        todos: {
          OPTIMIZE_STRATEGY: {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 1,
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            isTemporary: false,
            leftSection: "STRATEGY"
          },
          EVAL_MODEL_DRIVERS: {
            x: 9,
            y: 8,
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#247ADF",
            index: 0,
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: { x: 0, y: 1 },
              oChildDelta: { x: 0, y: 1 },
              sectionType: "DEPLOY"
            },
            actionId: 1,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            isTemporary: false,
            leftSection: "REVIEW_AI"
          }
        },
        hexMap: {
          "7_8": {
            x: 7,
            y: 8,
            id: "DEPLOY",
            icon: "Rocket",
            text: "I want to deploy the current AI",
            color: "#EC6417",
            index: 3,
            selected: {
              0: {
                id: "DEPLOY_REVIEW",
                text: "Review & Deploy AI",
                afterText: "AI Deployed",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "DEPLOY_SETTINGS"
              },
              1: {
                id: "DEPLOY_INTEGRATION",
                text: "Integrate Deployed AI",
                afterText: "Integration has been added",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "INTEGRATE"
              },
              2: {
                id: "DEPLOY_MONITOR",
                text: "Add Monitoring Settings",
                afterText: "Monitoring settings have been updated",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "MONITOR"
              }
            },
            background: "#EC6417",
            childDelta: { x: -1, y: 1 },
            oChildDelta: { x: -1, y: 0 },
            sectionType: "DEPLOY"
          },
          "8_7": {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          "8_9": {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: { x: 0, y: 1 },
            oChildDelta: { x: 0, y: 1 },
            sectionType: "DEPLOY"
          },
          "9_7": {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                hideSave: true,
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: { x: 1, y: 0 },
            oChildDelta: { x: 1, y: -1 },
            sectionType: "FAIRNESS"
          },
          "9_8": {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                hideSave: true,
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: { x: 1, y: 1 },
            oChildDelta: { x: 1, y: 1 },
            sectionType: "BUDGET"
          }
        },
        isTodo: true,
        centerHex: {
          x: {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "EXPECTED"
          },
          y: {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "EXPECTED"
          }
        },
        isLoading: false,
        beforeSetup: {},
        replayIndex: 1,
        savedHexMap: {
          "7_7": {
            x: 7,
            y: 8,
            icon: "Join",
            text: "Dataset Name",
            color: "#059669",
            isBase: true,
            leftSection: "DATASET"
          },
          "8_4": {
            x: 8,
            y: 8,
            id: "OPTIMIZE_STRATEGY",
            text: "Add Business Strategy Recommendations",
            color: "#7E69D7",
            index: 5,
            author: "Jonathan Wray",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 3,
            afterText: "Strategy Updated",
            hasUpdate: true,
            leftSection: "STRATEGY",
            updatedDate: 1675202856394
          },
          "8_5": {
            x: 9,
            y: 7,
            id: "OPTIMIZE_COSTS",
            text: "Add Business Costs and Benefits Calculations",
            color: "#7E69D7",
            index: 4,
            author: "Jonathan Wray",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 2,
            afterText: "Business costs and benefits have been defined",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "Subscription Sales",
              total: 20000,
              models: [],
              ignored: {},
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "7625",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -294, conversionGain: 1488, conversionSaved: 0, conversionMissed: 0 },
              fieldTypes: {},
              isForecast: false,
              isQuickRun: false,
              timePeriod: "Year",
              trueAction: "Pursue",
              blueprintId: 306,
              falseAction: "Deprioritize",
              isBlueprint: true,
              splitColumn: "Lead Source",
              advancedCost: 294,
              customValues: {
                Margin: 0.33,
                Avg_Deal_Size: 54000,
                Cost_Per_Lead: 130,
                Avg_Sales_Cost: 164,
                Opportunity_Rate: 0.1
              },
              fieldReplace: {},
              ignoredValue: {},
              modelOptions: [],
              outcomeLabel: "Successful Sale",
              processLimit: 0,
              pursuedRatio: "20",
              showBusiness: true,
              trueNegative: 13950,
              truePositive: 2000,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 1550,
              falsePositive: 8000,
              ignoredModels: {},
              conversionCost: -294,
              conversionGain: 1488,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Net Profit",
              advancedRevenue: 5400,
              conversionSaved: 0,
              notPursuedRatio: "10",
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: 0,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Opportunities",
              advancedCostLabel: "Sales Resourcing",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Cost",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly deprioritized",
              truePositiveLabel: "Prioritized Sale",
              falseNegativeLabel: "Missed opportunity",
              falsePositiveLabel: "Pursued but not won",
              underPredictAction: "Underestimate Cost",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              businessConstraints: [{ min: 1.5, mode: "percent", type: "revenue" }],
              humanUnderstandable: false,
              advancedRevenueLabel: "Revenue",
              baselineCustomValues: {},
              enableFairnessMetrics: false,
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Sales Leads"
            },
            isTemporary: true,
            leftSection: "EXPECTED",
            updatedDate: 1675202761748
          },
          "8_6": {
            x: 8,
            y: 6,
            id: "OPTIMIZE_BLUEPRINT",
            icon: "Blueprint",
            text: "Add Business Use Case Language",
            color: "#7E69D7",
            index: 2,
            author: "Aible Demo",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 0,
            afterText: " ",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "Subscription Sales",
              total: 20000,
              models: [],
              ignored: {},
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "7625",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              errorCosts: { conversionCost: -280, conversionGain: 770, conversionSaved: 0, conversionMissed: 0 },
              fieldTypes: {},
              isForecast: false,
              isQuickRun: false,
              timePeriod: "Year",
              trueAction: "Pursue",
              blueprintId: 134,
              falseAction: "Deprioritize",
              isBlueprint: true,
              splitColumn: "Lead Source",
              advancedCost: 280,
              customValues: {
                Margin: 0.3,
                Avg_Deal_Size: 50000,
                Cost_Per_Lead: 130,
                Variable_Cost: 0,
                Avg_Sales_Cost: 150,
                Opportunity_Rate: 0.07
              },
              fieldReplace: {},
              ignoredValue: {},
              modelOptions: [],
              outcomeLabel: "Successful Sale",
              processLimit: 0,
              pursuedRatio: "20",
              showBusiness: true,
              trueNegative: 13950,
              truePositive: 2000,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 1550,
              falsePositive: 8000,
              ignoredModels: {},
              conversionCost: -280,
              conversionGain: 770,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Net Profit",
              advancedRevenue: 3500.0000000000005,
              conversionSaved: 0,
              notPursuedRatio: "10",
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: 0,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Opportunities",
              advancedCostLabel: "Sales Resourcing",
              businessObjective: "Profit",
              fairnessObjective: "None",
              overPredictAction: "Overestimate Cost",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly deprioritized",
              truePositiveLabel: "Prioritized Sale",
              falseNegativeLabel: "Missed opportunity",
              falsePositiveLabel: "Pursued but not won",
              underPredictAction: "Underestimate Cost",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "Revenue",
              baselineCustomValues: {},
              enableFairnessMetrics: false,
              maximumConversionRate: 5,
              fairnessToleranceBound: 1,
              notPursuedTransactionLabel: "Sales Leads"
            },
            isTemporary: true,
            leftSection: "BLUEPRINT",
            updatedDate: 1635284191599
          },
          "8_8": {
            x: 8,
            y: 8,
            icon: "Blueprint",
            text: "Marketing Use Case",
            color: "#7e69d7",
            isBase: true,
            canStart: false,
            selected: {},
            leftSection: "HOME"
          },
          "8_10": {
            x: 9,
            y: 8,
            id: "EVAL_MODEL_DRIVERS",
            icon: "Gears",
            text: "Evaluate Model Drivers",
            color: "#247ADF",
            index: 3,
            author: "Aible Demo",
            parent: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: { x: 0, y: 1 },
              oChildDelta: { x: 0, y: 1 },
              sectionType: "DEPLOY"
            },
            actionId: 1,
            hideSave: true,
            hasUpdate: true,
            borderColor: "#247ADF",
            leftSection: "REVIEW_AI",
            updatedDate: 1635284198541
          }
        },
        actionHexMap: {},
        savedActions: [
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              leftSection: "BLUEPRINT"
            },
            hex: { x: 8, y: 6 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              },
              y: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              }
            },
            node: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "BLUEPRINT"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "BLUEPRINT"
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 8,
              y: 9,
              id: "PREDICT",
              icon: "Predict",
              text: "I want to see test predictions and understand model behavior",
              color: "#247ADF",
              index: 4,
              selected: {
                0: {
                  id: "PREDICT_WHAT_IF",
                  icon: "Stethoscope",
                  text: "Try test predictions",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "PREDICT_WHAT_IF"
                },
                1: {
                  id: "EVAL_MODEL_DRIVERS",
                  icon: "Gears",
                  text: "Evaluate Model Drivers",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "REVIEW_AI"
                },
                2: {
                  id: "REVIEW_MODEL_METRICS",
                  icon: "Table",
                  text: "Review Model Metrics",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_METRICS"
                },
                3: {
                  id: "REVIEW_MODEL_CHARTS",
                  icon: "Chart",
                  text: "Review Model Evaluation Charts",
                  hideSave: true,
                  hasUpdate: true,
                  borderColor: "#247ADF",
                  leftSection: "MODEL_CHARTS"
                }
              },
              background: "#247ADF",
              childDelta: { x: 0, y: 1 },
              oChildDelta: { x: 0, y: 1 },
              sectionType: "DEPLOY"
            },
            hex: { x: 8, y: 9 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 8,
              y: 8,
              id: "OPTIMIZE_STRATEGY",
              text: "Add Business Strategy Recommendations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 3,
              afterText: "Strategy Updated",
              hasUpdate: true,
              leftSection: "STRATEGY"
            },
            hex: { x: 8, y: 8 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              leftSection: "EXPECTED"
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              },
              y: {
                x: 9,
                y: 7,
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 2,
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "EXPECTED"
              }
            },
            node: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "EXPECTED"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "EXPECTED"
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 7,
              id: "OPTIMIZE_COSTS",
              text: "Add Business Costs and Benefits Calculations",
              color: "#7E69D7",
              index: 4,
              author: "Jonathan Wray",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 2,
              afterText: "Business costs and benefits have been defined",
              hasUpdate: true,
              setupStep: {},
              afterSetup: {
                goal: "Maximize",
                mode: 2,
                label: "Subscription Sales",
                total: 20000,
                models: [],
                ignored: {},
                useCase: "Sales Prediction",
                aimToHit: 800,
                endState: [],
                targeted: 2000,
                unitType: "$",
                auditable: false,
                datasetId: "7625",
                hideCosts: false,
                threshold: [0, 0],
                contAction: "Sell",
                errorCosts: { conversionCost: -294, conversionGain: 1488, conversionSaved: 0, conversionMissed: 0 },
                fieldTypes: {},
                isForecast: false,
                isQuickRun: false,
                timePeriod: "Year",
                trueAction: "Pursue",
                blueprintId: 306,
                falseAction: "Deprioritize",
                isBlueprint: true,
                splitColumn: "Lead Source",
                advancedCost: 294,
                customValues: {
                  Margin: 0.33,
                  Avg_Deal_Size: 54000,
                  Cost_Per_Lead: 130,
                  Avg_Sales_Cost: 164,
                  Opportunity_Rate: 0.1
                },
                fieldReplace: {},
                ignoredValue: {},
                modelOptions: [],
                outcomeLabel: "Successful Sale",
                processLimit: 0,
                pursuedRatio: "20",
                showBusiness: true,
                trueNegative: 13950,
                truePositive: 2000,
                advancedInput: {},
                biasReduction: "Impact",
                falseNegative: 1550,
                falsePositive: 8000,
                ignoredModels: {},
                conversionCost: -294,
                conversionGain: 1488,
                conversionRate: 5,
                customMappings: {},
                netImpactLabel: "Net Profit",
                advancedRevenue: 5400,
                conversionSaved: 0,
                notPursuedRatio: "10",
                numberPredicted: "Price",
                realTimeResults: false,
                aiTrainingBudget: 200,
                conversionMissed: 0,
                hasLinkedProject: false,
                isForceOptimized: false,
                transactionLabel: "Opportunities",
                advancedCostLabel: "Sales Resourcing",
                businessObjective: "Profit",
                fairnessObjective: "None",
                overPredictAction: "Overestimate Cost",
                overestimateLabel: "Overestimate",
                trueNegativeLabel: "Correctly deprioritized",
                truePositiveLabel: "Prioritized Sale",
                falseNegativeLabel: "Missed opportunity",
                falsePositiveLabel: "Pursued but not won",
                underPredictAction: "Underestimate Cost",
                underestimateLabel: "Underestimate",
                academicResultsStep: 0,
                businessConstraints: [{ min: 1.5, mode: "percent", type: "revenue" }],
                humanUnderstandable: false,
                advancedRevenueLabel: "Revenue",
                baselineCustomValues: {},
                enableFairnessMetrics: false,
                maximumConversionRate: 5,
                fairnessToleranceBound: 1,
                notPursuedTransactionLabel: "Sales Leads"
              },
              isTemporary: true,
              leftSection: "EXPECTED",
              updatedDate: 1675202761748
            },
            hex: { x: 9, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            type: "UPDATE_SELECTED_HEX",
            isInstant: true,
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              index: 2,
              author: "Aible Demo",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              setupStep: {},
              afterSetup: {
                goal: "Maximize",
                mode: 2,
                label: "Subscription Sales",
                total: 20000,
                models: [],
                ignored: {},
                useCase: "Sales Prediction",
                aimToHit: 800,
                endState: [],
                targeted: 2000,
                unitType: "$",
                auditable: false,
                datasetId: "7625",
                hideCosts: false,
                threshold: [0, 0],
                contAction: "Sell",
                errorCosts: { conversionCost: -280, conversionGain: 770, conversionSaved: 0, conversionMissed: 0 },
                fieldTypes: {},
                isForecast: false,
                isQuickRun: false,
                timePeriod: "Year",
                trueAction: "Pursue",
                blueprintId: 134,
                falseAction: "Deprioritize",
                isBlueprint: true,
                splitColumn: "Lead Source",
                advancedCost: 280,
                customValues: {
                  Margin: 0.3,
                  Avg_Deal_Size: 50000,
                  Cost_Per_Lead: 130,
                  Variable_Cost: 0,
                  Avg_Sales_Cost: 150,
                  Opportunity_Rate: 0.07
                },
                fieldReplace: {},
                ignoredValue: {},
                modelOptions: [],
                outcomeLabel: "Successful Sale",
                processLimit: 0,
                pursuedRatio: "20",
                showBusiness: true,
                trueNegative: 13950,
                truePositive: 2000,
                advancedInput: {},
                biasReduction: "Impact",
                falseNegative: 1550,
                falsePositive: 8000,
                ignoredModels: {},
                conversionCost: -280,
                conversionGain: 770,
                conversionRate: 5,
                customMappings: {},
                netImpactLabel: "Net Profit",
                advancedRevenue: 3500.0000000000005,
                conversionSaved: 0,
                notPursuedRatio: "10",
                numberPredicted: "Price",
                realTimeResults: false,
                aiTrainingBudget: 200,
                conversionMissed: 0,
                hasLinkedProject: false,
                isForceOptimized: false,
                transactionLabel: "Opportunities",
                advancedCostLabel: "Sales Resourcing",
                businessObjective: "Profit",
                fairnessObjective: "None",
                overPredictAction: "Overestimate Cost",
                overestimateLabel: "Overestimate",
                trueNegativeLabel: "Correctly deprioritized",
                truePositiveLabel: "Prioritized Sale",
                falseNegativeLabel: "Missed opportunity",
                falsePositiveLabel: "Pursued but not won",
                underPredictAction: "Underestimate Cost",
                underestimateLabel: "Underestimate",
                academicResultsStep: 0,
                humanUnderstandable: false,
                advancedRevenueLabel: "Revenue",
                baselineCustomValues: {},
                enableFairnessMetrics: false,
                maximumConversionRate: 5,
                fairnessToleranceBound: 1,
                notPursuedTransactionLabel: "Sales Leads"
              },
              isTemporary: true,
              leftSection: "BLUEPRINT",
              updatedDate: 1635284191599
            },
            hex: { x: 8, y: 6 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          { type: "HANDLE_BACK", isVisible: false }
        ],
        todoMaximize: { OPTIMIZE_BLUEPRINT: true },
        temporaryTodo: {
          x: 8,
          y: 6,
          id: "OPTIMIZE_BLUEPRINT",
          icon: "Blueprint",
          text: "Add Business Use Case Language",
          color: "#7E69D7",
          index: 2,
          author: "Aible Demo",
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          actionId: 0,
          afterText: " ",
          hasUpdate: true,
          setupStep: {},
          afterSetup: {
            goal: "Maximize",
            mode: 2,
            label: "Subscription Sales",
            total: 20000,
            models: [],
            ignored: {},
            useCase: "Sales Prediction",
            aimToHit: 800,
            endState: [],
            targeted: 2000,
            unitType: "$",
            auditable: false,
            datasetId: "7625",
            hideCosts: false,
            threshold: [0, 0],
            contAction: "Sell",
            errorCosts: { conversionCost: -280, conversionGain: 770, conversionSaved: 0, conversionMissed: 0 },
            fieldTypes: {},
            isForecast: false,
            isQuickRun: false,
            timePeriod: "Year",
            trueAction: "Pursue",
            blueprintId: 134,
            falseAction: "Deprioritize",
            isBlueprint: true,
            splitColumn: "Lead Source",
            advancedCost: 280,
            customValues: {
              Margin: 0.3,
              Avg_Deal_Size: 50000,
              Cost_Per_Lead: 130,
              Variable_Cost: 0,
              Avg_Sales_Cost: 150,
              Opportunity_Rate: 0.07
            },
            fieldReplace: {},
            ignoredValue: {},
            modelOptions: [],
            outcomeLabel: "Successful Sale",
            processLimit: 0,
            pursuedRatio: "20",
            showBusiness: true,
            trueNegative: 13950,
            truePositive: 2000,
            advancedInput: {},
            biasReduction: "Impact",
            falseNegative: 1550,
            falsePositive: 8000,
            ignoredModels: {},
            conversionCost: -280,
            conversionGain: 770,
            conversionRate: 5,
            customMappings: {},
            netImpactLabel: "Net Profit",
            advancedRevenue: 3500.0000000000005,
            conversionSaved: 0,
            notPursuedRatio: "10",
            numberPredicted: "Price",
            realTimeResults: false,
            aiTrainingBudget: 200,
            conversionMissed: 0,
            hasLinkedProject: false,
            isForceOptimized: false,
            transactionLabel: "Opportunities",
            advancedCostLabel: "Sales Resourcing",
            businessObjective: "Profit",
            fairnessObjective: "None",
            overPredictAction: "Overestimate Cost",
            overestimateLabel: "Overestimate",
            trueNegativeLabel: "Correctly deprioritized",
            truePositiveLabel: "Prioritized Sale",
            falseNegativeLabel: "Missed opportunity",
            falsePositiveLabel: "Pursued but not won",
            underPredictAction: "Underestimate Cost",
            underestimateLabel: "Underestimate",
            academicResultsStep: 0,
            humanUnderstandable: false,
            advancedRevenueLabel: "Revenue",
            baselineCustomValues: {},
            enableFairnessMetrics: false,
            maximumConversionRate: 5,
            fairnessToleranceBound: 1,
            notPursuedTransactionLabel: "Sales Leads"
          },
          isTemporary: true,
          leftSection: "BLUEPRINT",
          updatedDate: 1635284191599
        }
      }
    },
    sensitive: {},
    customFields: {
      Margin: { id: "Margin", desc: "Average product margin" },
      Avg_Deal_Size: { id: "Avg_Deal_Size", desc: "Average sales deal size" },
      Cost_Per_Lead: { id: "Cost_Per_Lead", desc: "Average cost per lead" },
      Avg_Sales_Cost: { id: "Avg_Sales_Cost", desc: "Average cost for actively pursuing a sale" },
      Opportunity_Rate: { id: "Opportunity_Rate", desc: "Percent of leads that become opportunities" }
    },
    advancedInputs: {
      advancedCost: "Cost_Per_Lead+Avg_Sales_Cost",
      trueNegative: "0",
      truePositive: "Avg_Deal_Size*Opportunity_Rate*Margin-(Cost_Per_Lead+Avg_Sales_Cost)",
      falseNegative: "0",
      falsePositive: "-(Cost_Per_Lead+Avg_Sales_Cost)",
      advancedRevenue: "Avg_Deal_Size*Opportunity_Rate"
    }
  }
};

const TELCO_CHURN = {
  ...DEFAULT_USE_CASE_SETTINGS,
  outcome_behavior: "MAXIMIZE",
  id: "TELCO_CHURN",
  name: "Telco Churn",
  suggested_fields: [],
  wizard: {
    setup: {
      goal: "Maximize",
      mode: 2,
      label: "Telco Churn",
      total: 20000,
      models: [],
      ignored: {},
      useCase: "Sales Prediction",
      aimToHit: 800,
      endState: [],
      targeted: 2000,
      unitType: "$",
      auditable: false,
      datasetId: "5622",
      hideCosts: false,
      threshold: [0, 0],
      contAction: "Sell",
      fieldTypes: {},
      isForecast: false,
      isQuickRun: false,
      timePeriod: "Month",
      trueAction: "Try to Retain",
      blueprintId: "3676",
      falseAction: "Ignore",
      isBlueprint: true,
      splitColumn: "Subscription Plan",
      advancedCost: "150",
      customFields: {
        CLV: { id: "CLV", desc: "Customer lifetime value" },
        Success_Rate: { id: "Success_Rate", desc: "Success rate of retention" },
        Retention_Cost: { id: "Retention_Cost", desc: "Cost of retention efforts" }
      },
      customValues: { CLV: "2500", Success_Rate: "0.3", Retention_Cost: "150" },
      fieldReplace: {},
      modelOptions: [],
      outcomeLabel: "Accounts Retained",
      processLimit: 0,
      pursuedRatio: "20",
      trueNegative: 212500,
      truePositive: 10209,
      advancedInput: {},
      biasReduction: "Impact",
      falseNegative: 37500,
      falsePositive: 40838,
      advancedInputs: {
        advancedCost: "Retention_Cost",
        trueNegative: "0",
        truePositive: "CLV*Success_Rate-Retention_Cost",
        falseNegative: "-CLV*Success_Rate",
        falsePositive: "-Retention_Cost",
        advancedRevenue: "CLV*Success_Rate"
      },
      conversionCost: -150,
      conversionGain: 600,
      conversionRate: 5,
      customMappings: {},
      netImpactLabel: "Impact",
      advancedRevenue: 750,
      conversionSaved: 0,
      notPursuedRatio: "15.00",
      numberPredicted: "Price",
      realTimeResults: false,
      aiTrainingBudget: 200,
      conversionMissed: -750,
      hasLinkedProject: false,
      isForceOptimized: false,
      transactionLabel: "Accounts",
      advancedCostLabel: "Retention Cost",
      businessObjective: "Profit",
      overPredictAction: "Cost of Overpricing",
      overestimateLabel: "Overestimate",
      trueNegativeLabel: "Correctly Ignored",
      truePositiveLabel: "Correct Retention",
      balancingObjective: "None",
      falseNegativeLabel: "Churn",
      falsePositiveLabel: "Incorrect Retention",
      underPredictAction: "Cost of Underpricing",
      underestimateLabel: "Underestimate",
      academicResultsStep: 0,
      humanUnderstandable: false,
      advancedRevenueLabel: "CLV Retained",
      baselineCustomValues: {},
      maximumConversionRate: 5,
      notPursuedTransactionLabel: "Accounts"
    },
    dataset: {
      id: "TELCO_CHURN",
      name: "Telco Churn Optimize_v2.csv",
      label: "Telco Churn Optimize_v2.csv",
      errors: [],
      fields: {
        Churn: { type: "categorical", label: "Churn" },
        AgeHH1: { type: "number", label: "AgeHH1" },
        AgeHH2: { type: "number", label: "AgeHH2" },
        RVOwner: { type: "categorical", label: "RVOwner" },
        Handsets: { type: "number", label: "Handsets" },
        PrizmCode: { type: "categorical", label: "PrizmCode" },
        ActiveSubs: { type: "number", label: "ActiveSubs" },
        CustomerID: { type: "number", label: "CustomerID" },
        Occupation: { type: "categorical", label: "Occupation" },
        TruckOwner: { type: "categorical", label: "TruckOwner" },
        UniqueSubs: { type: "number", label: "UniqueSubs" },
        IncomeGroup: { type: "number", label: "IncomeGroup" },
        NonUSTravel: { type: "categorical", label: "NonUSTravel" },
        BlockedCalls: { type: "number", label: "BlockedCalls" },
        ChildrenInHH: { type: "categorical", label: "ChildrenInHH" },
        CreditRating: { type: "categorical", label: "CreditRating" },
        DroppedCalls: { type: "number", label: "DroppedCalls" },
        InboundCalls: { type: "number", label: "InboundCalls" },
        OwnsComputer: { type: "categorical", label: "OwnsComputer" },
        RoamingCalls: { type: "number", label: "RoamingCalls" },
        HandsetModels: { type: "number", label: "HandsetModels" },
        HasCreditCard: { type: "categorical", label: "HasCreditCard" },
        Homeownership: { type: "categorical", label: "Homeownership" },
        OutboundCalls: { type: "number", label: "OutboundCalls" },
        ReceivedCalls: { type: "number", label: "ReceivedCalls" },
        ThreewayCalls: { type: "number", label: "ThreewayCalls" },
        MonthlyMinutes: { type: "number", label: "MonthlyMinutes" },
        MonthlyRevenue: { type: "number", label: "MonthlyRevenue" },
        OptOutMailings: { type: "categorical", label: "OptOutMailings" },
        OverageMinutes: { type: "number", label: "OverageMinutes" },
        OwnsMotorcycle: { type: "categorical", label: "OwnsMotorcycle" },
        PeakCallsInOut: { type: "number", label: "PeakCallsInOut" },
        RetentionCalls: { type: "categorical", label: "RetentionCalls" },
        MonthsInService: { type: "number", label: "MonthsInService" },
        UnansweredCalls: { type: "number", label: "UnansweredCalls" },
        BuysViaMailOrder: { type: "categorical", label: "BuysViaMailOrder" },
        CallWaitingCalls: { type: "number", label: "CallWaitingCalls" },
        NewCellphoneUser: { type: "categorical", label: "NewCellphoneUser" },
        CustomerCareCalls: { type: "number", label: "CustomerCareCalls" },
        HandsetWebCapable: { type: "categorical", label: "HandsetWebCapable" },
        OffPeakCallsInOut: { type: "number", label: "OffPeakCallsInOut" },
        PercChangeMinutes: { type: "number", label: "PercChangeMinutes" },
        "Subscription Plan": { type: "categorical", label: "Subscription Plan" },
        HandsetRefurbished: { type: "categorical", label: "HandsetRefurbished" },
        PercChangeRevenues: { type: "number", label: "PercChangeRevenues" },
        CallForwardingCalls: { type: "number", label: "CallForwardingCalls" },
        DroppedBlockedCalls: { type: "number", label: "DroppedBlockedCalls" },
        NotNewCellphoneUser: { type: "categorical", label: "NotNewCellphoneUser" },
        CurrentEquipmentDays: { type: "number", label: "CurrentEquipmentDays" },
        RespondsToMailOffers: { type: "categorical", label: "RespondsToMailOffers" },
        TotalRecurringCharge: { type: "number", label: "TotalRecurringCharge" },
        DirectorAssistedCalls: { type: "number", label: "DirectorAssistedCalls" },
        MadeCallToRetentionTeam: { type: "categorical", label: "MadeCallToRetentionTeam" },
        RetentionOffersAccepted: { type: "categorical", label: "RetentionOffersAccepted" },
        AdjustmentsToCreditRating: { type: "number", label: "AdjustmentsToCreditRating" },
        ReferralsMadeBySubscriber: { type: "number", label: "ReferralsMadeBySubscriber" }
      },
      labels: [
        "CustomerID",
        "MonthlyRevenue",
        "MonthlyMinutes",
        "TotalRecurringCharge",
        "DirectorAssistedCalls",
        "OverageMinutes",
        "RoamingCalls",
        "PercChangeMinutes",
        "PercChangeRevenues",
        "DroppedCalls",
        "BlockedCalls",
        "UnansweredCalls",
        "CustomerCareCalls",
        "ThreewayCalls",
        "ReceivedCalls",
        "OutboundCalls",
        "InboundCalls",
        "PeakCallsInOut",
        "OffPeakCallsInOut",
        "DroppedBlockedCalls",
        "CallForwardingCalls",
        "CallWaitingCalls",
        "MonthsInService",
        "UniqueSubs",
        "ActiveSubs",
        "Handsets",
        "HandsetModels",
        "CurrentEquipmentDays",
        "AgeHH1",
        "AgeHH2",
        "ChildrenInHH",
        "HandsetRefurbished",
        "HandsetWebCapable",
        "TruckOwner",
        "RVOwner",
        "Homeownership",
        "BuysViaMailOrder",
        "RespondsToMailOffers",
        "OptOutMailings",
        "NonUSTravel",
        "OwnsComputer",
        "HasCreditCard",
        "RetentionCalls",
        "RetentionOffersAccepted",
        "NewCellphoneUser",
        "NotNewCellphoneUser",
        "ReferralsMadeBySubscriber",
        "IncomeGroup",
        "OwnsMotorcycle",
        "AdjustmentsToCreditRating",
        "MadeCallToRetentionTeam",
        "CreditRating",
        "PrizmCode",
        "Occupation",
        "Subscription Plan",
        "Churn"
      ],
      source: {
        url: "s3://aible-366725415255-1026/uploads/prod/uploads/tenant_1/a6f850/raw",
        type: {
          id: 1,
          status: "ACTIVE",
          pattern: "s3:\\/\\/([^/]+)(?=\\/)\\/?(.*)",
          service_name: "S3",
          provider_name: "Amazon"
        },
        content: { type: "RAW_DATA" }
      },
      status: ["indexed"],
      target: "Churn",
      created: "2020-12-22T18:08:36",
      deleted: false,
      outcome: "Churn",
      isHidden: true,
      rowCount: 51047,
      stack_id: null,
      warnings: [
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column MonthlyRevenue has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "MonthlyRevenue",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column MonthlyRevenue has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:09"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column MonthlyMinutes has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "MonthlyMinutes",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column MonthlyMinutes has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:09"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column TotalRecurringCharge has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "TotalRecurringCharge",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column TotalRecurringCharge has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:09"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column DirectorAssistedCalls has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "DirectorAssistedCalls",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column DirectorAssistedCalls has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:09"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column OverageMinutes has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "OverageMinutes",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column OverageMinutes has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:10"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column RoamingCalls has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column.",
          metadata: {
            column: "RoamingCalls",
            percentage: 0.3056007209042647,
            num_missing: 156,
            num_observed: 50891,
            unique_message:
              " Column RoamingCalls has 156 missing values out of 51047 total values, comprising 0.3056007209042647 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:10"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column PercChangeMinutes has 367 missing values out of 51047 total values, comprising 0.7189452857170843 % of the data in this column.",
          metadata: {
            column: "PercChangeMinutes",
            percentage: 0.7189452857170843,
            num_missing: 367,
            num_observed: 50680,
            unique_message:
              " Column PercChangeMinutes has 367 missing values out of 51047 total values, comprising 0.7189452857170843 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:10"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column PercChangeRevenues has 367 missing values out of 51047 total values, comprising 0.7189452857170843 % of the data in this column.",
          metadata: {
            column: "PercChangeRevenues",
            percentage: 0.7189452857170843,
            num_missing: 367,
            num_observed: 50680,
            unique_message:
              " Column PercChangeRevenues has 367 missing values out of 51047 total values, comprising 0.7189452857170843 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:10"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column Handsets has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column.",
          metadata: {
            column: "Handsets",
            percentage: 0.0019589789801555428,
            num_missing: 1,
            num_observed: 51046,
            unique_message:
              " Column Handsets has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:10"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column HandsetModels has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column.",
          metadata: {
            column: "HandsetModels",
            percentage: 0.0019589789801555428,
            num_missing: 1,
            num_observed: 51046,
            unique_message:
              " Column HandsetModels has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:11"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column CurrentEquipmentDays has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column.",
          metadata: {
            column: "CurrentEquipmentDays",
            percentage: 0.0019589789801555428,
            num_missing: 1,
            num_observed: 51046,
            unique_message:
              " Column CurrentEquipmentDays has 1 missing values out of 51047 total values, comprising 0.0019589789801555428 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:11"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column AgeHH1 has 909 missing values out of 51047 total values, comprising 1.7807118929613885 % of the data in this column.",
          metadata: {
            column: "AgeHH1",
            percentage: 1.7807118929613885,
            num_missing: 909,
            num_observed: 50138,
            unique_message:
              " Column AgeHH1 has 909 missing values out of 51047 total values, comprising 1.7807118929613885 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:11"
        },
        {
          code: "MissingValuesWarning",
          type: "warning",
          scope: "",
          message:
            "Missing values column. These would be treated as a separate “missing” category.  Column AgeHH2 has 909 missing values out of 51047 total values, comprising 1.7807118929613885 % of the data in this column.",
          metadata: {
            column: "AgeHH2",
            percentage: 1.7807118929613885,
            num_missing: 909,
            num_observed: 50138,
            unique_message:
              " Column AgeHH2 has 909 missing values out of 51047 total values, comprising 1.7807118929613885 % of the data in this column."
          },
          created_date: "2020-12-22T18:09:11"
        }
      ],
      accountId: 1026,
      file_size: 10,
      folder_id: 163,
      recipe_id: null,
      sourceUrl: "s3://aible-366725415255-1026/uploads/prod/uploads/tenant_1/a6f850/raw",
      tenant_id: 1,
      account_id: 1026,
      created_by: { id: 10, fullname: "Test Aible" },
      hasRulefit: false,
      like_count: 0,
      annotations: [
        {
          type: "info",
          scope: "*",
          message:
            "Started Lambda Stack at arn:aws:lambda::us-east-1:validate-headers-c8eeb835cf8843cfa5937509ac0a8eb8",
          created_date: "2020-12-22T18:08:39"
        },
        {
          type: "info",
          scope: "*",
          message: "Started Lambda Stack at arn:aws:lambda::us-east-1:data-analysis-c8513c8ed53a413d8e8416dd007fd57e",
          created_date: "2020-12-22T18:10:08"
        }
      ],
      permissions: { can_edit: true, can_view: true, can_delete: true, can_manage_permissions: true },
      created_date: "2020-12-22T18:08:36",
      descriptions: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      target_index: 55,
      updated_date: "2020-12-22T18:11:37",
      comment_count: 0,
      dislike_count: 0,
      dataset_status: "DONE",
      number_of_rows: 51047,
      overall_status: ["indexed"],
      schema_monitor_id: null,
      categorical_counts: [
        [
          "ChildrenInHH",
          [
            ["No", 38679],
            ["Yes", 12368]
          ]
        ],
        [
          "HandsetRefurbished",
          [
            ["No", 43956],
            ["Yes", 7091]
          ]
        ],
        [
          "HandsetWebCapable",
          [
            ["No", 5001],
            ["Yes", 46046]
          ]
        ],
        [
          "TruckOwner",
          [
            ["No", 41524],
            ["Yes", 9523]
          ]
        ],
        [
          "RVOwner",
          [
            ["No", 46894],
            ["Yes", 4153]
          ]
        ],
        [
          "Homeownership",
          [
            ["Known", 33987],
            ["Unknown", 17060]
          ]
        ],
        [
          "BuysViaMailOrder",
          [
            ["No", 32596],
            ["Yes", 18451]
          ]
        ],
        [
          "RespondsToMailOffers",
          [
            ["No", 31821],
            ["Yes", 19226]
          ]
        ],
        [
          "OptOutMailings",
          [
            ["No", 50295],
            ["Yes", 752]
          ]
        ],
        [
          "NonUSTravel",
          [
            ["No", 48168],
            ["Yes", 2879]
          ]
        ],
        [
          "OwnsComputer",
          [
            ["No", 41583],
            ["Yes", 9464]
          ]
        ],
        [
          "HasCreditCard",
          [
            ["No", 16544],
            ["Yes", 34503]
          ]
        ],
        [
          "RetentionCalls",
          [
            ["0", 49302],
            ["1", 1609],
            ["2", 120],
            ["3", 14],
            ["4", 2]
          ]
        ],
        [
          "RetentionOffersAccepted",
          [
            ["0", 50166],
            ["1", 837],
            ["2", 36],
            ["3", 8]
          ]
        ],
        [
          "NewCellphoneUser",
          [
            ["No", 41223],
            ["Yes", 9824]
          ]
        ],
        [
          "NotNewCellphoneUser",
          [
            ["No", 44012],
            ["Yes", 7035]
          ]
        ],
        [
          "OwnsMotorcycle",
          [
            ["No", 50368],
            ["Yes", 679]
          ]
        ],
        [
          "MadeCallToRetentionTeam",
          [
            ["No", 49302],
            ["Yes", 1745]
          ]
        ],
        [
          "CreditRating",
          [
            ["1-Highest", 8522],
            ["2-High", 18993],
            ["3-Good", 8410],
            ["4-Medium", 5357],
            ["5-Low", 6499],
            ["6-VeryLow", 1152],
            ["7-Lowest", 2114]
          ]
        ],
        [
          "PrizmCode",
          [
            ["Other", 24655],
            ["Rural", 2425],
            ["Suburban", 16378],
            ["Town", 7589]
          ]
        ],
        [
          "Occupation",
          [
            ["Clerical", 986],
            ["Crafts", 1519],
            ["Homemaker", 157],
            ["Other", 37637],
            ["Professional", 8755],
            ["Retired", 733],
            ["Self", 879],
            ["Student", 381]
          ]
        ],
        [
          "Subscription Plan",
          [
            ["Commercial", 18651],
            ["Mobile", 19700],
            ["Residential", 12696]
          ]
        ],
        [
          "Churn",
          [
            ["No", 36336],
            ["Yes", 14711]
          ]
        ]
      ],
      rulefit_definitions: []
    },
    nextObj: {
      todos: {},
      modelsReducer: {
        hexMap: {
          "7_8": {
            x: 7,
            y: 8,
            id: "DEPLOY",
            icon: "Rocket",
            text: "I want to deploy the current AI",
            color: "#EC6417",
            index: 3,
            selected: {
              0: {
                id: "DEPLOY_REVIEW",
                text: "Review & Deploy AI",
                afterText: "AI Deployed",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "DEPLOY_SETTINGS"
              },
              1: {
                id: "DEPLOY_INTEGRATION",
                text: "Integrate Deployed AI",
                afterText: "Integration has been added",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "INTEGRATE"
              },
              2: {
                id: "DEPLOY_MONITOR",
                text: "Add Monitoring Settings",
                afterText: "Monitoring settings have been updated",
                hasUpdate: true,
                borderColor: "#EC6417",
                leftSection: "MONITOR"
              }
            },
            background: "#EC6417",
            childDelta: { x: -1, y: 1 },
            oChildDelta: { x: -1, y: 0 },
            sectionType: "DEPLOY"
          },
          "8_7": {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          "8_9": {
            x: 8,
            y: 9,
            id: "PREDICT",
            icon: "Predict",
            text: "I want to see test predictions and understand model behavior",
            color: "#247ADF",
            index: 4,
            selected: {
              0: {
                id: "PREDICT_WHAT_IF",
                icon: "Stethoscope",
                text: "Try test predictions",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "PREDICT_WHAT_IF"
              },
              1: {
                id: "EVAL_MODEL_DRIVERS",
                icon: "Gears",
                text: "Evaluate Model Drivers",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "REVIEW_AI"
              },
              2: {
                id: "REVIEW_MODEL_METRICS",
                icon: "Table",
                text: "Review Model Metrics",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_METRICS"
              },
              3: {
                id: "REVIEW_MODEL_CHARTS",
                icon: "Chart",
                text: "Review Model Evaluation Charts",
                hideSave: true,
                hasUpdate: true,
                borderColor: "#247ADF",
                leftSection: "MODEL_CHARTS"
              }
            },
            background: "#247ADF",
            childDelta: { x: 0, y: 1 },
            oChildDelta: { x: 0, y: 1 },
            sectionType: "DEPLOY"
          },
          "9_7": {
            x: 9,
            y: 7,
            id: "FAIR",
            icon: "Fairness",
            text: "I want to add fairness goals and guidelines",
            color: "#54C06C",
            index: 1,
            selected: {
              0: {
                id: "FAIR_VALUE",
                text: "What Subgroup Do you want to Optimize for?",
                hideSave: true,
                afterText: "Subgroup focus: undefined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "SUBGROUP"
              },
              1: {
                id: "FAIR_GUIDE",
                text: "Add AI Fairness Guidelines",
                afterText: "Fairness guidelines have been defined",
                hasUpdate: true,
                borderColor: "#54C06C",
                leftSection: "FAIR_GUIDE"
              }
            },
            background: "#54C06C",
            childDelta: { x: 1, y: 0 },
            oChildDelta: { x: 1, y: -1 },
            sectionType: "FAIRNESS"
          },
          "9_8": {
            x: 9,
            y: 8,
            id: "BUDGET",
            icon: "Resource",
            text: "I want Aible to find the optimal resource allocation across subgroups",
            color: "#00B5D0",
            index: 2,
            selected: {
              0: {
                id: "BUDGET_SUBGROUP",
                text: "Select Subgroup",
                hideSave: true,
                afterText: "A subgroup has been selected",
                hasUpdate: true,
                borderColor: "#00B5D0",
                leftSection: "SUBGROUP"
              }
            },
            background: "#00B5D0",
            childDelta: { x: 1, y: 1 },
            oChildDelta: { x: 1, y: 1 },
            sectionType: "BUDGET"
          }
        },
        isTodo: true,
        centerHex: {
          x: {
            x: 8,
            y: 6,
            id: "OPTIMIZE_BLUEPRINT",
            icon: "Blueprint",
            text: "Add Business Use Case Language",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 0,
            afterText: " ",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "BLUEPRINT"
          },
          y: {
            x: 8,
            y: 6,
            id: "OPTIMIZE_BLUEPRINT",
            icon: "Blueprint",
            text: "Add Business Use Case Language",
            color: "#7E69D7",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 0,
            afterText: " ",
            hasUpdate: true,
            isTemporary: true,
            leftSection: "BLUEPRINT"
          }
        },
        isLoading: false,
        beforeSetup: {},
        replayIndex: 2,
        savedHexMap: {
          "7_7": {
            x: 7,
            y: 8,
            icon: "Join",
            text: "Dataset Name",
            color: "#059669",
            isBase: true,
            leftSection: "DATASET"
          },
          "8_5": {
            x: 8,
            y: 6,
            id: "OPTIMIZE_BLUEPRINT",
            icon: "Blueprint",
            text: "Add Business Use Case Language",
            color: "#7E69D7",
            index: 4,
            author: "Jonathan Wray",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 0,
            afterText: " ",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "Telco Churn",
              total: 20000,
              models: [],
              ignored: {},
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "5622",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              fieldTypes: {},
              isForecast: false,
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Try to Retain",
              blueprintId: "3676",
              falseAction: "Ignore",
              isBlueprint: true,
              splitColumn: "Subscription Plan",
              advancedCost: "150",
              customFields: {
                CLV: { id: "CLV", desc: "Customer lifetime value" },
                Success_Rate: { id: "Success_Rate", desc: "Success rate of retention" },
                Retention_Cost: { id: "Retention_Cost", desc: "Cost of retention efforts" }
              },
              customValues: { CLV: "2500", Success_Rate: "0.3", Retention_Cost: "150" },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Accounts Retained",
              processLimit: 0,
              pursuedRatio: "20",
              trueNegative: 212500,
              truePositive: 10209,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 37500,
              falsePositive: 40838,
              advancedInputs: {
                advancedCost: "Retention_Cost",
                trueNegative: "0",
                truePositive: "CLV*Success_Rate-Retention_Cost",
                falseNegative: "-CLV*Success_Rate",
                falsePositive: "-Retention_Cost",
                advancedRevenue: "CLV*Success_Rate"
              },
              conversionCost: -150,
              conversionGain: 600,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 750,
              conversionSaved: 0,
              notPursuedRatio: "15.00",
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -750,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Accounts",
              advancedCostLabel: "Retention Cost",
              businessObjective: "Profit",
              overPredictAction: "Cost of Overpricing",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Ignored",
              truePositiveLabel: "Correct Retention",
              balancingObjective: "None",
              falseNegativeLabel: "Churn",
              falsePositiveLabel: "Incorrect Retention",
              underPredictAction: "Cost of Underpricing",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "CLV Retained",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              notPursuedTransactionLabel: "Accounts"
            },
            isTemporary: true,
            leftSection: "BLUEPRINT",
            updatedDate: 1751921778124
          },
          "8_6": {
            x: 9,
            y: 6,
            id: "OPTIMIZE_TRANSACTION",
            text: "Add Baseline Business Behavior",
            color: "#7E69D7",
            index: 2,
            author: "Jonathan Wray",
            parent: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            actionId: 1,
            afterText: "Baseline behavior has been defined",
            hasUpdate: true,
            setupStep: {},
            afterSetup: {
              goal: "Maximize",
              mode: 2,
              label: "Telco Churn",
              total: 20000,
              models: [],
              ignored: {},
              useCase: "Sales Prediction",
              aimToHit: 800,
              endState: [],
              targeted: 2000,
              unitType: "$",
              auditable: false,
              datasetId: "5622",
              hideCosts: false,
              threshold: [0, 0],
              contAction: "Sell",
              fieldTypes: {},
              isForecast: false,
              isQuickRun: false,
              timePeriod: "Month",
              trueAction: "Attempt to Retain",
              blueprintId: "309",
              falseAction: "Ignore",
              isBlueprint: true,
              splitColumn: "Subscription Plan",
              advancedCost: "150",
              customFields: {
                CLV: { id: "CLV", desc: "Customer lifetime value" },
                Success_Rate: { id: "Success_Rate", desc: "Success rate of retention" },
                Retention_Cost: { id: "Retention_Cost", desc: "Cost of retention efforts" }
              },
              customValues: { CLV: "2500", Success_Rate: "0.3", Retention_Cost: "150" },
              fieldReplace: {},
              modelOptions: [],
              outcomeLabel: "Customer Churn",
              processLimit: 0,
              pursuedRatio: "20",
              trueNegative: 212500,
              truePositive: 10209,
              advancedInput: {},
              biasReduction: "Impact",
              falseNegative: 37500,
              falsePositive: 40838,
              advancedInputs: {
                advancedCost: "Retention_Cost",
                trueNegative: "0",
                truePositive: "CLV*Success_Rate-Retention_Cost",
                falseNegative: "-CLV*Success_Rate",
                falsePositive: "-Retention_Cost",
                advancedRevenue: "CLV*Success_Rate"
              },
              conversionCost: -150,
              conversionGain: 600,
              conversionRate: 5,
              customMappings: {},
              netImpactLabel: "Impact",
              advancedRevenue: 750,
              conversionSaved: 0,
              notPursuedRatio: "15.00",
              numberPredicted: "Price",
              realTimeResults: false,
              aiTrainingBudget: 200,
              conversionMissed: -750,
              hasLinkedProject: false,
              isForceOptimized: false,
              transactionLabel: "Customers",
              advancedCostLabel: "Retention Cost",
              businessObjective: "Profit",
              overPredictAction: "Cost of Overpricing",
              overestimateLabel: "Overestimate",
              trueNegativeLabel: "Correctly Ignored",
              truePositiveLabel: "Correct Retention",
              balancingObjective: "None",
              falseNegativeLabel: "Churn",
              falsePositiveLabel: "Incorrect Retention",
              underPredictAction: "Cost of Underpricing",
              underestimateLabel: "Underestimate",
              academicResultsStep: 0,
              humanUnderstandable: false,
              advancedRevenueLabel: "CLV Retained",
              baselineCustomValues: {},
              maximumConversionRate: 5,
              notPursuedTransactionLabel: "Customers"
            },
            isTemporary: true,
            leftSection: "BASELINE",
            updatedDate: 1711990686034
          },
          "8_8": {
            x: 8,
            y: 8,
            icon: "Blueprint",
            text: "Marketing Use Case",
            color: "#7e69d7",
            isBase: true,
            canStart: false,
            selected: {},
            leftSection: "HOME"
          }
        },
        selectedHex: {
          x: 8,
          y: 6,
          id: "OPTIMIZE_BLUEPRINT",
          icon: "Blueprint",
          text: "Add Business Use Case Language",
          color: "#7E69D7",
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          actionId: 0,
          afterText: " ",
          hasUpdate: true,
          leftSection: "BLUEPRINT"
        },
        actionHexMap: {},
        savedActions: [
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 9,
              y: 6,
              id: "OPTIMIZE_TRANSACTION",
              text: "Add Baseline Business Behavior",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 1,
              afterText: "Baseline behavior has been defined",
              hasUpdate: true,
              leftSection: "BASELINE"
            },
            hex: { x: 9, y: 6 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 9,
                y: 6,
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 1,
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BASELINE"
              },
              y: {
                x: 9,
                y: 6,
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 1,
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BASELINE"
              }
            },
            node: {
              x: 9,
              y: 6,
              id: "OPTIMIZE_TRANSACTION",
              text: "Add Baseline Business Behavior",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 1,
              afterText: "Baseline behavior has been defined",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "BASELINE"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "BASELINE"
          },
          {
            n: {
              x: 8,
              y: 7,
              id: "OPTIMIZE",
              icon: "Business",
              text: "Can this AI help my current business process?",
              color: "#7E69D7",
              index: 0,
              selected: {
                0: {
                  id: "OPTIMIZE_BLUEPRINT",
                  icon: "Blueprint",
                  text: "Add Business Use Case Language",
                  afterText: " ",
                  hasUpdate: true,
                  leftSection: "BLUEPRINT"
                },
                1: {
                  id: "OPTIMIZE_TRANSACTION",
                  text: "Add Baseline Business Behavior",
                  afterText: "Baseline behavior has been defined",
                  hasUpdate: true,
                  leftSection: "BASELINE"
                },
                2: {
                  id: "OPTIMIZE_COSTS",
                  text: "Add Business Costs and Benefits Calculations",
                  afterText: "Business costs and benefits have been defined",
                  hasUpdate: true,
                  leftSection: "EXPECTED"
                },
                3: {
                  id: "OPTIMIZE_STRATEGY",
                  text: "Add Business Strategy Recommendations",
                  afterText: "Strategy Updated",
                  hasUpdate: true,
                  leftSection: "STRATEGY"
                },
                4: {
                  id: "OPTIMIZE_BALANCER",
                  text: "Balance Costs from another Project",
                  afterText: "Project Linked",
                  hasUpdate: true,
                  leftSection: "BALANCER"
                }
              },
              childDelta: { x: 0, y: -1 },
              sectionType: "STRATEGY"
            },
            hex: { x: 8, y: 7 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            n: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              leftSection: "BLUEPRINT"
            },
            hex: { x: 8, y: 6 },
            type: "UPDATE_SELECTED_HEX",
            isVisible: false,
            beforeSetup: {}
          },
          {
            hex: {
              x: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              },
              y: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              }
            },
            node: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "BLUEPRINT"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "BLUEPRINT"
          },
          {
            hex: {
              x: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              },
              y: {
                x: 8,
                y: 6,
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                color: "#7E69D7",
                parent: {
                  x: 8,
                  y: 7,
                  id: "OPTIMIZE",
                  icon: "Business",
                  text: "Can this AI help my current business process?",
                  color: "#7E69D7",
                  index: 0,
                  selected: {
                    0: {
                      id: "OPTIMIZE_BLUEPRINT",
                      icon: "Blueprint",
                      text: "Add Business Use Case Language",
                      afterText: " ",
                      hasUpdate: true,
                      leftSection: "BLUEPRINT"
                    },
                    1: {
                      id: "OPTIMIZE_TRANSACTION",
                      text: "Add Baseline Business Behavior",
                      afterText: "Baseline behavior has been defined",
                      hasUpdate: true,
                      leftSection: "BASELINE"
                    },
                    2: {
                      id: "OPTIMIZE_COSTS",
                      text: "Add Business Costs and Benefits Calculations",
                      afterText: "Business costs and benefits have been defined",
                      hasUpdate: true,
                      leftSection: "EXPECTED"
                    },
                    3: {
                      id: "OPTIMIZE_STRATEGY",
                      text: "Add Business Strategy Recommendations",
                      afterText: "Strategy Updated",
                      hasUpdate: true,
                      leftSection: "STRATEGY"
                    },
                    4: {
                      id: "OPTIMIZE_BALANCER",
                      text: "Balance Costs from another Project",
                      afterText: "Project Linked",
                      hasUpdate: true,
                      leftSection: "BALANCER"
                    }
                  },
                  childDelta: { x: 0, y: -1 },
                  sectionType: "STRATEGY"
                },
                actionId: 0,
                afterText: " ",
                hasUpdate: true,
                isTemporary: true,
                leftSection: "BLUEPRINT"
              }
            },
            node: {
              x: 8,
              y: 6,
              id: "OPTIMIZE_BLUEPRINT",
              icon: "Blueprint",
              text: "Add Business Use Case Language",
              color: "#7E69D7",
              parent: {
                x: 8,
                y: 7,
                id: "OPTIMIZE",
                icon: "Business",
                text: "Can this AI help my current business process?",
                color: "#7E69D7",
                index: 0,
                selected: {
                  0: {
                    id: "OPTIMIZE_BLUEPRINT",
                    icon: "Blueprint",
                    text: "Add Business Use Case Language",
                    afterText: " ",
                    hasUpdate: true,
                    leftSection: "BLUEPRINT"
                  },
                  1: {
                    id: "OPTIMIZE_TRANSACTION",
                    text: "Add Baseline Business Behavior",
                    afterText: "Baseline behavior has been defined",
                    hasUpdate: true,
                    leftSection: "BASELINE"
                  },
                  2: {
                    id: "OPTIMIZE_COSTS",
                    text: "Add Business Costs and Benefits Calculations",
                    afterText: "Business costs and benefits have been defined",
                    hasUpdate: true,
                    leftSection: "EXPECTED"
                  },
                  3: {
                    id: "OPTIMIZE_STRATEGY",
                    text: "Add Business Strategy Recommendations",
                    afterText: "Strategy Updated",
                    hasUpdate: true,
                    leftSection: "STRATEGY"
                  },
                  4: {
                    id: "OPTIMIZE_BALANCER",
                    text: "Balance Costs from another Project",
                    afterText: "Project Linked",
                    hasUpdate: true,
                    leftSection: "BALANCER"
                  }
                },
                childDelta: { x: 0, y: -1 },
                sectionType: "STRATEGY"
              },
              actionId: 0,
              afterText: " ",
              hasUpdate: true,
              isTemporary: true,
              leftSection: "BLUEPRINT"
            },
            type: "HANDLE_UPDATE",
            mType: "MODELS",
            setupStep: {},
            afterSetup: {},
            leftSection: "BLUEPRINT"
          }
        ],
        todoMaximize: { OPTIMIZE_BLUEPRINT: true },
        temporaryTodo: {
          x: 8,
          y: 6,
          id: "OPTIMIZE_BLUEPRINT",
          icon: "Blueprint",
          text: "Add Business Use Case Language",
          color: "#7E69D7",
          parent: {
            x: 8,
            y: 7,
            id: "OPTIMIZE",
            icon: "Business",
            text: "Can this AI help my current business process?",
            color: "#7E69D7",
            index: 0,
            selected: {
              0: {
                id: "OPTIMIZE_BLUEPRINT",
                icon: "Blueprint",
                text: "Add Business Use Case Language",
                afterText: " ",
                hasUpdate: true,
                leftSection: "BLUEPRINT"
              },
              1: {
                id: "OPTIMIZE_TRANSACTION",
                text: "Add Baseline Business Behavior",
                afterText: "Baseline behavior has been defined",
                hasUpdate: true,
                leftSection: "BASELINE"
              },
              2: {
                id: "OPTIMIZE_COSTS",
                text: "Add Business Costs and Benefits Calculations",
                afterText: "Business costs and benefits have been defined",
                hasUpdate: true,
                leftSection: "EXPECTED"
              },
              3: {
                id: "OPTIMIZE_STRATEGY",
                text: "Add Business Strategy Recommendations",
                afterText: "Strategy Updated",
                hasUpdate: true,
                leftSection: "STRATEGY"
              },
              4: {
                id: "OPTIMIZE_BALANCER",
                text: "Balance Costs from another Project",
                afterText: "Project Linked",
                hasUpdate: true,
                leftSection: "BALANCER"
              }
            },
            childDelta: { x: 0, y: -1 },
            sectionType: "STRATEGY"
          },
          actionId: 0,
          afterText: " ",
          hasUpdate: true,
          isTemporary: true,
          leftSection: "BLUEPRINT"
        }
      }
    },
    sensitive: {},
    customFields: {
      CLV: { id: "CLV", desc: "Customer lifetime value" },
      Success_Rate: { id: "Success_Rate", desc: "Success rate of retention" },
      Retention_Cost: { id: "Retention_Cost", desc: "Cost of retention efforts" }
    },
    advancedInputs: {
      advancedCost: "Retention_Cost",
      trueNegative: "0",
      truePositive: "CLV*Success_Rate-Retention_Cost",
      falseNegative: "-CLV*Success_Rate",
      falsePositive: "-Retention_Cost",
      advancedRevenue: "CLV*Success_Rate"
    }
  }
};

export default {
  [BANK_LOAN_FAIRNESS.id]: { ...BANK_LOAN_FAIRNESS },
  [HOSPITAL_READMISSION.id]: { ...HOSPITAL_READMISSION },
  [SUBSCRIPTION_SALES.id]: { ...SUBSCRIPTION_SALES },
  [TELCO_CHURN.id]: { ...TELCO_CHURN }
};
